/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root";
import { Route as consoleIndexRouteImport } from "./routes/console/index";
import { Route as consoleAuthedRouteImport } from "./routes/console/authed";
import { Route as ForgotPasswordRouteImport } from "./routes/console/public/forgot-password";
import { Route as ResetPasswordRouteImport } from "./routes/console/public/reset-password";
import { Route as SignInRouteImport } from "./routes/console/public/sign-in";
import { Route as SignUpRouteImport } from "./routes/console/public/sign-up";
import { Route as VerifyEmailRouteImport } from "./routes/console/public/verify-email";
import { Route as consoleOrgRouteImport } from "./routes/console/org";
import { Route as consoleAccountRouteImport } from "./routes/console/account";
import { Route as marketplaceIndexRouteImport } from "./routes/marketplace/index";
import { Route as MfaRouteImport } from "./routes/console/authed/mfa";
import { Route as MovedRouteImport } from "./routes/console/authed/moved";
import { Route as OnboardingRouteImport } from "./routes/console/authed/onboarding";
import { Route as marketplaceWorkspaceRouteImport } from "./routes/marketplace/workspace";
import { Route as AuthDotcallbackRouteImport } from "./routes/console/public/auth.callback";
import { Route as consoleOrgIndexRouteImport } from "./routes/console/org-index";
import { Route as consoleProjectRouteImport } from "./routes/console/project";
import { Route as IndexRouteImport } from "./routes/account/index";
import { Route as PrivacyRouteImport } from "./routes/account/privacy";
import { Route as ProfileRouteImport } from "./routes/account/profile";
import { Route as SecurityRouteImport } from "./routes/account/security";
import { Route as SshkeysRouteImport } from "./routes/account/sshkeys";
import { Route as CliAuthDotindexRouteImport } from "./routes/console/authed/cli-auth.index";
import { Route as CliAuthDotdeviceRouteImport } from "./routes/console/authed/cli-auth.device";
import { Route as InviteDottokenRouteImport } from "./routes/console/authed/invite.$token";
import { Route as marketplaceOrgRouteImport } from "./routes/marketplace/org";
import { Route as OauthDotconsentRouteImport } from "./routes/console/authed/oauth.consent";
import { Route as marketplaceViewRouteImport } from "./routes/marketplace/view";
import { Route as consoleProjectIndexRouteImport } from "./routes/console/project-index";
import { Route as AssetsRouteImport } from "./routes/console/project/assets";
import { Route as ComputeRouteImport } from "./routes/console/project/compute";
import { Route as OverviewRouteImport } from "./routes/console/project/overview";
import { Route as RunsRouteImport } from "./routes/runs/runs";
import { Route as UiCatalogRouteImport } from "./routes/console/project/ui-catalog";
import { Route as BillingDotindexRouteImport } from "./routes/billing/billing.index";
import { Route as BillingDottabRouteImport } from "./routes/billing/billing.$tab";
import { Route as IntegrationsIndexRouteImport } from "./routes/connections/org/index";
import { Route as IntegrationsMcpRouteImport } from "./routes/connections/org/mcp";
import { Route as SettingsIndexRouteImport } from "./routes/settings/org/index";
import { Route as SettingsApikeysRouteImport } from "./routes/settings/org/apikeys";
import { Route as SettingsAuditRouteImport } from "./routes/settings/org/audit";
import { Route as SettingsComputeRouteImport } from "./routes/settings/org/compute";
import { Route as SettingsGeneralRouteImport } from "./routes/settings/org/general";
import { Route as SettingsInvitesRouteImport } from "./routes/settings/org/invites";
import { Route as SettingsMembersRouteImport } from "./routes/settings/org/members";
import { Route as SettingsQuotasRouteImport } from "./routes/settings/org/quotas";
import { Route as SpotDotindexRouteImport } from "./routes/spot/spot.index";
import { Route as SpotDotsettingsRouteImport } from "./routes/spot/spot.settings";
import { Route as SpotDotusageRouteImport } from "./routes/spot/spot.usage";
import { Route as TeamIndexRouteImport } from "./routes/team/index";
import { Route as TeamDomainsRouteImport } from "./routes/team/domains";
import { Route as TeamInvitesRouteImport } from "./routes/team/invites";
import { Route as TeamMembersRouteImport } from "./routes/team/members";
import { Route as TeamProjectsRouteImport } from "./routes/team/projects";
import { Route as AgentsDotindexRouteImport } from "./routes/agents/agents.index";
import { Route as AppsDotnameRouteImport } from "./routes/functions/apps.$name";
import { Route as ConnectionsIndexRouteImport } from "./routes/connections/project/index";
import { Route as ConnectionsNameRouteImport } from "./routes/connections/project/$name";
import { Route as ConnectionsNewRouteImport } from "./routes/connections/project/new";
import { Route as EnvironmentsDotindexRouteImport } from "./routes/training/environments.index";
import { Route as EnvironmentsDotnameRouteImport } from "./routes/training/environments.$name";
import { Route as FunctionsDotindexRouteImport } from "./routes/functions/functions.index";
import { Route as ImagesDotindexRouteImport } from "./routes/storage/images.index";
import { Route as InferenceDotindexRouteImport } from "./routes/inference/inference.index";
import { Route as InferenceendpointsDotnewRouteImport } from "./routes/inference/inferenceendpoints.new";
import { Route as InstancesDotindexRouteImport } from "./routes/instances/instances.index";
import { Route as InstancesDotnewRouteImport } from "./routes/instances/instances.new";
import { Route as JobsDotnewRouteImport } from "./routes/runs/jobs.new";
import { Route as PoolsIndexRouteImport } from "./routes/infrastructure/project/index";
import { Route as PoolsNewRouteImport } from "./routes/infrastructure/project/new";
import { Route as ReservedhostsDotindexRouteImport } from "./routes/reserved-hosts/reservedhosts.index";
import { Route as ReservedhostsDotrequestsRouteImport } from "./routes/reserved-hosts/reservedhosts.requests";
import { Route as SandboxesDotindexRouteImport } from "./routes/sandboxes/sandboxes.index";
import { Route as SandboxesDotnewRouteImport } from "./routes/sandboxes/sandboxes.new";
import { Route as SecretsDotindexRouteImport } from "./routes/storage/secrets.index";
import { Route as SecretsDotnameRouteImport } from "./routes/storage/secrets.$name";
import { Route as ServiceaccountsIndexRouteImport } from "./routes/settings/project/index";
import { Route as ServiceaccountsNameRouteImport } from "./routes/settings/project/$name";
import { Route as TrainingjobsDotindexRouteImport } from "./routes/training/trainingjobs.index";
import { Route as TrainingruntimesDotnameRouteImport } from "./routes/training/trainingruntimes.$name";
import { Route as VolumesDotindexRouteImport } from "./routes/storage/volumes.index";
import { Route as WorkspacesDotindexRouteImport } from "./routes/workspaces/workspaces.index";
import { Route as WorkspacesDotnewRouteImport } from "./routes/workspaces/workspaces.new";
import { Route as BillingDotbudgetsDotnameRouteImport } from "./routes/billing/billing.budgets.$name";
import { Route as InfrastructureCloudaccountsDotindexRouteImport } from "./routes/infrastructure/org/cloudaccounts.index";
import { Route as InfrastructureCloudaccountsDotnameRouteImport } from "./routes/infrastructure/org/cloudaccounts.$name";
import { Route as InfrastructureNodesDotindexRouteImport } from "./routes/infrastructure/org/nodes.index";
import { Route as InfrastructureNodesDotnameRouteImport } from "./routes/infrastructure/org/nodes.$name";
import { Route as SettingsWebhooksDotindexRouteImport } from "./routes/settings/org/webhooks.index";
import { Route as SettingsWebhooksDotnameRouteImport } from "./routes/settings/org/webhooks.$name";
import { Route as AgentgroupsDotnameDottabRouteImport } from "./routes/agents/agentgroups.$name.$tab";
import { Route as AgentrunsDotnameDottabRouteImport } from "./routes/agents/agentruns.$name.$tab";
import { Route as AgentsDotnameDottabRouteImport } from "./routes/agents/agents.$name.$tab";
import { Route as FunctionsDotnameDottabRouteImport } from "./routes/functions/functions.$name.$tab";
import { Route as ImagesDotnameDotindexRouteImport } from "./routes/storage/images.$name.index";
import { Route as ImagesDotnameDottabRouteImport } from "./routes/storage/images.$name.$tab";
import { Route as InferenceendpointsDotnameDotindexRouteImport } from "./routes/inference/inferenceendpoints.$name.index";
import { Route as InferenceendpointsDotnameDottabRouteImport } from "./routes/inference/inferenceendpoints.$name.$tab";
import { Route as InstancesDotnameDottabRouteImport } from "./routes/instances/instances.$name.$tab";
import { Route as JobsDotnameDottabRouteImport } from "./routes/runs/jobs.$name.$tab";
import { Route as PipelinesDotnameDottabRouteImport } from "./routes/runs/pipelines.$name.$tab";
import { Route as PoolsNameDotindexRouteImport } from "./routes/infrastructure/project/$name.index";
import { Route as PoolsNameDottabRouteImport } from "./routes/infrastructure/project/$name.$tab";
import { Route as ReservedhostsDotnameDottabRouteImport } from "./routes/reserved-hosts/reservedhosts.$name.$tab";
import { Route as SandboxesDotnameDottabRouteImport } from "./routes/sandboxes/sandboxes.$name.$tab";
import { Route as SweepsDotnameDottabRouteImport } from "./routes/runs/sweeps.$name.$tab";
import { Route as TrainingjobsDotnameDottabRouteImport } from "./routes/training/trainingjobs.$name.$tab";
import { Route as VolumesDotnameDotindexRouteImport } from "./routes/storage/volumes.$name.index";
import { Route as VolumesDotnameDottabRouteImport } from "./routes/storage/volumes.$name.$tab";
import { Route as WorkspacesDotnameDottabRouteImport } from "./routes/workspaces/workspaces.$name.$tab";
import { Route as InfrastructureCloudaccountsDotnewDotawsRouteImport } from "./routes/infrastructure/org/cloudaccounts.new.aws";
import { Route as InfrastructureCloudaccountsDotnewDotazureRouteImport } from "./routes/infrastructure/org/cloudaccounts.new.azure";
import { Route as InfrastructureCloudaccountsDotnewDotgcpRouteImport } from "./routes/infrastructure/org/cloudaccounts.new.gcp";
import { Route as InfrastructureCloudaccountsDotnewDotkeyRouteImport } from "./routes/infrastructure/org/cloudaccounts.new.key";
import { Route as InfrastructureCloudaccountsDotnewDotkubernetesRouteImport } from "./routes/infrastructure/org/cloudaccounts.new.kubernetes";
import { Route as InfrastructureCloudaccountsDotnewDotazure_DotcallbackRouteImport } from "./routes/infrastructure/org/cloudaccounts.new.azure_.callback";
import { Route as InfrastructureCloudaccountsDotnewDotgcp_DotcallbackRouteImport } from "./routes/infrastructure/org/cloudaccounts.new.gcp_.callback";

const consoleIndexRoute = consoleIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any);
const consoleAuthedRoute = consoleAuthedRouteImport.update({
  id: "/_authed",
  getParentRoute: () => rootRouteImport,
} as any);
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: "/forgot-password",
  path: "/forgot-password",
  getParentRoute: () => rootRouteImport,
} as any);
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: "/reset-password",
  path: "/reset-password",
  getParentRoute: () => rootRouteImport,
} as any);
const SignInRoute = SignInRouteImport.update({
  id: "/sign-in",
  path: "/sign-in",
  getParentRoute: () => rootRouteImport,
} as any);
const SignUpRoute = SignUpRouteImport.update({
  id: "/sign-up",
  path: "/sign-up",
  getParentRoute: () => rootRouteImport,
} as any);
const VerifyEmailRoute = VerifyEmailRouteImport.update({
  id: "/verify-email",
  path: "/verify-email",
  getParentRoute: () => rootRouteImport,
} as any);
const consoleOrgRoute = consoleOrgRouteImport.update({
  id: "/$org",
  path: "/$org",
  getParentRoute: () => consoleAuthedRoute,
} as any);
const consoleAccountRoute = consoleAccountRouteImport.update({
  id: "/account",
  path: "/account",
  getParentRoute: () => consoleAuthedRoute,
} as any);
const marketplaceIndexRoute = marketplaceIndexRouteImport.update({
  id: "/marketplace",
  path: "/marketplace",
  getParentRoute: () => consoleAuthedRoute,
} as any);
const MfaRoute = MfaRouteImport.update({
  id: "/mfa",
  path: "/mfa",
  getParentRoute: () => consoleAuthedRoute,
} as any);
const MovedRoute = MovedRouteImport.update({
  id: "/moved",
  path: "/moved",
  getParentRoute: () => consoleAuthedRoute,
} as any);
const OnboardingRoute = OnboardingRouteImport.update({
  id: "/onboarding",
  path: "/onboarding",
  getParentRoute: () => consoleAuthedRoute,
} as any);
const marketplaceWorkspaceRoute = marketplaceWorkspaceRouteImport.update({
  id: "/reserved-compute",
  path: "/reserved-compute",
  getParentRoute: () => consoleAuthedRoute,
} as any);
const AuthDotcallbackRoute = AuthDotcallbackRouteImport.update({
  id: "/auth/callback",
  path: "/auth/callback",
  getParentRoute: () => rootRouteImport,
} as any);
const consoleOrgIndexRoute = consoleOrgIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => consoleOrgRoute,
} as any);
const consoleProjectRoute = consoleProjectRouteImport.update({
  id: "/$project",
  path: "/$project",
  getParentRoute: () => consoleOrgRoute,
} as any);
const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => consoleAccountRoute,
} as any);
const PrivacyRoute = PrivacyRouteImport.update({
  id: "/privacy",
  path: "/privacy",
  getParentRoute: () => consoleAccountRoute,
} as any);
const ProfileRoute = ProfileRouteImport.update({
  id: "/profile",
  path: "/profile",
  getParentRoute: () => consoleAccountRoute,
} as any);
const SecurityRoute = SecurityRouteImport.update({
  id: "/security",
  path: "/security",
  getParentRoute: () => consoleAccountRoute,
} as any);
const SshkeysRoute = SshkeysRouteImport.update({
  id: "/sshkeys",
  path: "/sshkeys",
  getParentRoute: () => consoleAccountRoute,
} as any);
const CliAuthDotindexRoute = CliAuthDotindexRouteImport.update({
  id: "/cli-auth/",
  path: "/cli-auth/",
  getParentRoute: () => consoleAuthedRoute,
} as any);
const CliAuthDotdeviceRoute = CliAuthDotdeviceRouteImport.update({
  id: "/cli-auth/device",
  path: "/cli-auth/device",
  getParentRoute: () => consoleAuthedRoute,
} as any);
const InviteDottokenRoute = InviteDottokenRouteImport.update({
  id: "/invite/$token",
  path: "/invite/$token",
  getParentRoute: () => consoleAuthedRoute,
} as any);
const marketplaceOrgRoute = marketplaceOrgRouteImport.update({
  id: "/marketplace/$marketOrg",
  path: "/marketplace/$marketOrg",
  getParentRoute: () => consoleAuthedRoute,
} as any);
const OauthDotconsentRoute = OauthDotconsentRouteImport.update({
  id: "/oauth/consent",
  path: "/oauth/consent",
  getParentRoute: () => consoleAuthedRoute,
} as any);
const marketplaceViewRoute = marketplaceViewRouteImport.update({
  id: "/$marketView",
  path: "/$marketView",
  getParentRoute: () => marketplaceWorkspaceRoute,
} as any);
const consoleProjectIndexRoute = consoleProjectIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => consoleProjectRoute,
} as any);
const AssetsRoute = AssetsRouteImport.update({
  id: "/assets",
  path: "/assets",
  getParentRoute: () => consoleProjectRoute,
} as any);
const ComputeRoute = ComputeRouteImport.update({
  id: "/compute",
  path: "/compute",
  getParentRoute: () => consoleProjectRoute,
} as any);
const OverviewRoute = OverviewRouteImport.update({
  id: "/overview",
  path: "/overview",
  getParentRoute: () => consoleProjectRoute,
} as any);
const RunsRoute = RunsRouteImport.update({
  id: "/runs",
  path: "/runs",
  getParentRoute: () => consoleProjectRoute,
} as any);
const UiCatalogRoute = UiCatalogRouteImport.update({
  id: "/ui-catalog",
  path: "/ui-catalog",
  getParentRoute: () => consoleProjectRoute,
} as any);
const BillingDotindexRoute = BillingDotindexRouteImport.update({
  id: "/billing/",
  path: "/billing/",
  getParentRoute: () => consoleOrgRoute,
} as any);
const BillingDottabRoute = BillingDottabRouteImport.update({
  id: "/billing/$tab",
  path: "/billing/$tab",
  getParentRoute: () => consoleOrgRoute,
} as any);
const IntegrationsIndexRoute = IntegrationsIndexRouteImport.update({
  id: "/integrations/",
  path: "/integrations/",
  getParentRoute: () => consoleOrgRoute,
} as any);
const IntegrationsMcpRoute = IntegrationsMcpRouteImport.update({
  id: "/integrations/mcp",
  path: "/integrations/mcp",
  getParentRoute: () => consoleOrgRoute,
} as any);
const SettingsIndexRoute = SettingsIndexRouteImport.update({
  id: "/settings/",
  path: "/settings/",
  getParentRoute: () => consoleOrgRoute,
} as any);
const SettingsApikeysRoute = SettingsApikeysRouteImport.update({
  id: "/settings/apikeys",
  path: "/settings/apikeys",
  getParentRoute: () => consoleOrgRoute,
} as any);
const SettingsAuditRoute = SettingsAuditRouteImport.update({
  id: "/settings/audit",
  path: "/settings/audit",
  getParentRoute: () => consoleOrgRoute,
} as any);
const SettingsComputeRoute = SettingsComputeRouteImport.update({
  id: "/settings/compute",
  path: "/settings/compute",
  getParentRoute: () => consoleOrgRoute,
} as any);
const SettingsGeneralRoute = SettingsGeneralRouteImport.update({
  id: "/settings/general",
  path: "/settings/general",
  getParentRoute: () => consoleOrgRoute,
} as any);
const SettingsInvitesRoute = SettingsInvitesRouteImport.update({
  id: "/settings/invites",
  path: "/settings/invites",
  getParentRoute: () => consoleOrgRoute,
} as any);
const SettingsMembersRoute = SettingsMembersRouteImport.update({
  id: "/settings/members",
  path: "/settings/members",
  getParentRoute: () => consoleOrgRoute,
} as any);
const SettingsQuotasRoute = SettingsQuotasRouteImport.update({
  id: "/settings/quotas",
  path: "/settings/quotas",
  getParentRoute: () => consoleOrgRoute,
} as any);
const SpotDotindexRoute = SpotDotindexRouteImport.update({
  id: "/spot/",
  path: "/spot/",
  getParentRoute: () => consoleOrgRoute,
} as any);
const SpotDotsettingsRoute = SpotDotsettingsRouteImport.update({
  id: "/spot/settings",
  path: "/spot/settings",
  getParentRoute: () => consoleOrgRoute,
} as any);
const SpotDotusageRoute = SpotDotusageRouteImport.update({
  id: "/spot/usage",
  path: "/spot/usage",
  getParentRoute: () => consoleOrgRoute,
} as any);
const TeamIndexRoute = TeamIndexRouteImport.update({
  id: "/team/",
  path: "/team/",
  getParentRoute: () => consoleOrgRoute,
} as any);
const TeamDomainsRoute = TeamDomainsRouteImport.update({
  id: "/team/domains",
  path: "/team/domains",
  getParentRoute: () => consoleOrgRoute,
} as any);
const TeamInvitesRoute = TeamInvitesRouteImport.update({
  id: "/team/invites",
  path: "/team/invites",
  getParentRoute: () => consoleOrgRoute,
} as any);
const TeamMembersRoute = TeamMembersRouteImport.update({
  id: "/team/members",
  path: "/team/members",
  getParentRoute: () => consoleOrgRoute,
} as any);
const TeamProjectsRoute = TeamProjectsRouteImport.update({
  id: "/team/projects",
  path: "/team/projects",
  getParentRoute: () => consoleOrgRoute,
} as any);
const AgentsDotindexRoute = AgentsDotindexRouteImport.update({
  id: "/agents/",
  path: "/agents/",
  getParentRoute: () => consoleProjectRoute,
} as any);
const AppsDotnameRoute = AppsDotnameRouteImport.update({
  id: "/apps/$name",
  path: "/apps/$name",
  getParentRoute: () => consoleProjectRoute,
} as any);
const ConnectionsIndexRoute = ConnectionsIndexRouteImport.update({
  id: "/connections/",
  path: "/connections/",
  getParentRoute: () => consoleProjectRoute,
} as any);
const ConnectionsNameRoute = ConnectionsNameRouteImport.update({
  id: "/connections/$name",
  path: "/connections/$name",
  getParentRoute: () => consoleProjectRoute,
} as any);
const ConnectionsNewRoute = ConnectionsNewRouteImport.update({
  id: "/connections/new",
  path: "/connections/new",
  getParentRoute: () => consoleProjectRoute,
} as any);
const EnvironmentsDotindexRoute = EnvironmentsDotindexRouteImport.update({
  id: "/environments/",
  path: "/environments/",
  getParentRoute: () => consoleProjectRoute,
} as any);
const EnvironmentsDotnameRoute = EnvironmentsDotnameRouteImport.update({
  id: "/environments/$name",
  path: "/environments/$name",
  getParentRoute: () => consoleProjectRoute,
} as any);
const FunctionsDotindexRoute = FunctionsDotindexRouteImport.update({
  id: "/functions/",
  path: "/functions/",
  getParentRoute: () => consoleProjectRoute,
} as any);
const ImagesDotindexRoute = ImagesDotindexRouteImport.update({
  id: "/images/",
  path: "/images/",
  getParentRoute: () => consoleProjectRoute,
} as any);
const InferenceDotindexRoute = InferenceDotindexRouteImport.update({
  id: "/inference/",
  path: "/inference/",
  getParentRoute: () => consoleProjectRoute,
} as any);
const InferenceendpointsDotnewRoute =
  InferenceendpointsDotnewRouteImport.update({
    id: "/inferenceendpoints/new",
    path: "/inferenceendpoints/new",
    getParentRoute: () => consoleProjectRoute,
  } as any);
const InstancesDotindexRoute = InstancesDotindexRouteImport.update({
  id: "/instances/",
  path: "/instances/",
  getParentRoute: () => consoleProjectRoute,
} as any);
const InstancesDotnewRoute = InstancesDotnewRouteImport.update({
  id: "/instances/new",
  path: "/instances/new",
  getParentRoute: () => consoleProjectRoute,
} as any);
const JobsDotnewRoute = JobsDotnewRouteImport.update({
  id: "/jobs/new",
  path: "/jobs/new",
  getParentRoute: () => consoleProjectRoute,
} as any);
const PoolsIndexRoute = PoolsIndexRouteImport.update({
  id: "/pools/",
  path: "/pools/",
  getParentRoute: () => consoleProjectRoute,
} as any);
const PoolsNewRoute = PoolsNewRouteImport.update({
  id: "/pools/new",
  path: "/pools/new",
  getParentRoute: () => consoleProjectRoute,
} as any);
const ReservedhostsDotindexRoute = ReservedhostsDotindexRouteImport.update({
  id: "/reservedhosts/",
  path: "/reservedhosts/",
  getParentRoute: () => consoleProjectRoute,
} as any);
const ReservedhostsDotrequestsRoute =
  ReservedhostsDotrequestsRouteImport.update({
    id: "/reservedhosts/requests",
    path: "/reservedhosts/requests",
    getParentRoute: () => consoleProjectRoute,
  } as any);
const SandboxesDotindexRoute = SandboxesDotindexRouteImport.update({
  id: "/sandboxes/",
  path: "/sandboxes/",
  getParentRoute: () => consoleProjectRoute,
} as any);
const SandboxesDotnewRoute = SandboxesDotnewRouteImport.update({
  id: "/sandboxes/new",
  path: "/sandboxes/new",
  getParentRoute: () => consoleProjectRoute,
} as any);
const SecretsDotindexRoute = SecretsDotindexRouteImport.update({
  id: "/secrets/",
  path: "/secrets/",
  getParentRoute: () => consoleProjectRoute,
} as any);
const SecretsDotnameRoute = SecretsDotnameRouteImport.update({
  id: "/secrets/$name",
  path: "/secrets/$name",
  getParentRoute: () => consoleProjectRoute,
} as any);
const ServiceaccountsIndexRoute = ServiceaccountsIndexRouteImport.update({
  id: "/serviceaccounts/",
  path: "/serviceaccounts/",
  getParentRoute: () => consoleProjectRoute,
} as any);
const ServiceaccountsNameRoute = ServiceaccountsNameRouteImport.update({
  id: "/serviceaccounts/$name",
  path: "/serviceaccounts/$name",
  getParentRoute: () => consoleProjectRoute,
} as any);
const TrainingjobsDotindexRoute = TrainingjobsDotindexRouteImport.update({
  id: "/trainingjobs/",
  path: "/trainingjobs/",
  getParentRoute: () => consoleProjectRoute,
} as any);
const TrainingruntimesDotnameRoute = TrainingruntimesDotnameRouteImport.update({
  id: "/trainingruntimes/$name",
  path: "/trainingruntimes/$name",
  getParentRoute: () => consoleProjectRoute,
} as any);
const VolumesDotindexRoute = VolumesDotindexRouteImport.update({
  id: "/volumes/",
  path: "/volumes/",
  getParentRoute: () => consoleProjectRoute,
} as any);
const WorkspacesDotindexRoute = WorkspacesDotindexRouteImport.update({
  id: "/workspaces/",
  path: "/workspaces/",
  getParentRoute: () => consoleProjectRoute,
} as any);
const WorkspacesDotnewRoute = WorkspacesDotnewRouteImport.update({
  id: "/workspaces/new",
  path: "/workspaces/new",
  getParentRoute: () => consoleProjectRoute,
} as any);
const BillingDotbudgetsDotnameRoute =
  BillingDotbudgetsDotnameRouteImport.update({
    id: "/billing/budgets/$name",
    path: "/billing/budgets/$name",
    getParentRoute: () => consoleOrgRoute,
  } as any);
const InfrastructureCloudaccountsDotindexRoute =
  InfrastructureCloudaccountsDotindexRouteImport.update({
    id: "/infrastructure/cloudaccounts/",
    path: "/infrastructure/cloudaccounts/",
    getParentRoute: () => consoleOrgRoute,
  } as any);
const InfrastructureCloudaccountsDotnameRoute =
  InfrastructureCloudaccountsDotnameRouteImport.update({
    id: "/infrastructure/cloudaccounts/$name",
    path: "/infrastructure/cloudaccounts/$name",
    getParentRoute: () => consoleOrgRoute,
  } as any);
const InfrastructureNodesDotindexRoute =
  InfrastructureNodesDotindexRouteImport.update({
    id: "/infrastructure/nodes/",
    path: "/infrastructure/nodes/",
    getParentRoute: () => consoleOrgRoute,
  } as any);
const InfrastructureNodesDotnameRoute =
  InfrastructureNodesDotnameRouteImport.update({
    id: "/infrastructure/nodes/$name",
    path: "/infrastructure/nodes/$name",
    getParentRoute: () => consoleOrgRoute,
  } as any);
const SettingsWebhooksDotindexRoute =
  SettingsWebhooksDotindexRouteImport.update({
    id: "/settings/webhooks/",
    path: "/settings/webhooks/",
    getParentRoute: () => consoleOrgRoute,
  } as any);
const SettingsWebhooksDotnameRoute = SettingsWebhooksDotnameRouteImport.update({
  id: "/settings/webhooks/$name",
  path: "/settings/webhooks/$name",
  getParentRoute: () => consoleOrgRoute,
} as any);
const AgentgroupsDotnameDottabRoute =
  AgentgroupsDotnameDottabRouteImport.update({
    id: "/agentgroups/$name/$tab",
    path: "/agentgroups/$name/$tab",
    getParentRoute: () => consoleProjectRoute,
  } as any);
const AgentrunsDotnameDottabRoute = AgentrunsDotnameDottabRouteImport.update({
  id: "/agentruns/$name/$tab",
  path: "/agentruns/$name/$tab",
  getParentRoute: () => consoleProjectRoute,
} as any);
const AgentsDotnameDottabRoute = AgentsDotnameDottabRouteImport.update({
  id: "/agents/$name/$tab",
  path: "/agents/$name/$tab",
  getParentRoute: () => consoleProjectRoute,
} as any);
const FunctionsDotnameDottabRoute = FunctionsDotnameDottabRouteImport.update({
  id: "/functions/$name/$tab",
  path: "/functions/$name/$tab",
  getParentRoute: () => consoleProjectRoute,
} as any);
const ImagesDotnameDotindexRoute = ImagesDotnameDotindexRouteImport.update({
  id: "/images/$name/",
  path: "/images/$name/",
  getParentRoute: () => consoleProjectRoute,
} as any);
const ImagesDotnameDottabRoute = ImagesDotnameDottabRouteImport.update({
  id: "/images/$name/$tab",
  path: "/images/$name/$tab",
  getParentRoute: () => consoleProjectRoute,
} as any);
const InferenceendpointsDotnameDotindexRoute =
  InferenceendpointsDotnameDotindexRouteImport.update({
    id: "/inferenceendpoints/$name/",
    path: "/inferenceendpoints/$name/",
    getParentRoute: () => consoleProjectRoute,
  } as any);
const InferenceendpointsDotnameDottabRoute =
  InferenceendpointsDotnameDottabRouteImport.update({
    id: "/inferenceendpoints/$name/$tab",
    path: "/inferenceendpoints/$name/$tab",
    getParentRoute: () => consoleProjectRoute,
  } as any);
const InstancesDotnameDottabRoute = InstancesDotnameDottabRouteImport.update({
  id: "/instances/$name/$tab",
  path: "/instances/$name/$tab",
  getParentRoute: () => consoleProjectRoute,
} as any);
const JobsDotnameDottabRoute = JobsDotnameDottabRouteImport.update({
  id: "/jobs/$name/$tab",
  path: "/jobs/$name/$tab",
  getParentRoute: () => consoleProjectRoute,
} as any);
const PipelinesDotnameDottabRoute = PipelinesDotnameDottabRouteImport.update({
  id: "/pipelines/$name/$tab",
  path: "/pipelines/$name/$tab",
  getParentRoute: () => consoleProjectRoute,
} as any);
const PoolsNameDotindexRoute = PoolsNameDotindexRouteImport.update({
  id: "/pools/$name/",
  path: "/pools/$name/",
  getParentRoute: () => consoleProjectRoute,
} as any);
const PoolsNameDottabRoute = PoolsNameDottabRouteImport.update({
  id: "/pools/$name/$tab",
  path: "/pools/$name/$tab",
  getParentRoute: () => consoleProjectRoute,
} as any);
const ReservedhostsDotnameDottabRoute =
  ReservedhostsDotnameDottabRouteImport.update({
    id: "/reservedhosts/$name/$tab",
    path: "/reservedhosts/$name/$tab",
    getParentRoute: () => consoleProjectRoute,
  } as any);
const SandboxesDotnameDottabRoute = SandboxesDotnameDottabRouteImport.update({
  id: "/sandboxes/$name/$tab",
  path: "/sandboxes/$name/$tab",
  getParentRoute: () => consoleProjectRoute,
} as any);
const SweepsDotnameDottabRoute = SweepsDotnameDottabRouteImport.update({
  id: "/sweeps/$name/$tab",
  path: "/sweeps/$name/$tab",
  getParentRoute: () => consoleProjectRoute,
} as any);
const TrainingjobsDotnameDottabRoute =
  TrainingjobsDotnameDottabRouteImport.update({
    id: "/trainingjobs/$name/$tab",
    path: "/trainingjobs/$name/$tab",
    getParentRoute: () => consoleProjectRoute,
  } as any);
const VolumesDotnameDotindexRoute = VolumesDotnameDotindexRouteImport.update({
  id: "/volumes/$name/",
  path: "/volumes/$name/",
  getParentRoute: () => consoleProjectRoute,
} as any);
const VolumesDotnameDottabRoute = VolumesDotnameDottabRouteImport.update({
  id: "/volumes/$name/$tab",
  path: "/volumes/$name/$tab",
  getParentRoute: () => consoleProjectRoute,
} as any);
const WorkspacesDotnameDottabRoute = WorkspacesDotnameDottabRouteImport.update({
  id: "/workspaces/$name/$tab",
  path: "/workspaces/$name/$tab",
  getParentRoute: () => consoleProjectRoute,
} as any);
const InfrastructureCloudaccountsDotnewDotawsRoute =
  InfrastructureCloudaccountsDotnewDotawsRouteImport.update({
    id: "/infrastructure/cloudaccounts/new/aws",
    path: "/infrastructure/cloudaccounts/new/aws",
    getParentRoute: () => consoleOrgRoute,
  } as any);
const InfrastructureCloudaccountsDotnewDotazureRoute =
  InfrastructureCloudaccountsDotnewDotazureRouteImport.update({
    id: "/infrastructure/cloudaccounts/new/azure",
    path: "/infrastructure/cloudaccounts/new/azure",
    getParentRoute: () => consoleOrgRoute,
  } as any);
const InfrastructureCloudaccountsDotnewDotgcpRoute =
  InfrastructureCloudaccountsDotnewDotgcpRouteImport.update({
    id: "/infrastructure/cloudaccounts/new/gcp",
    path: "/infrastructure/cloudaccounts/new/gcp",
    getParentRoute: () => consoleOrgRoute,
  } as any);
const InfrastructureCloudaccountsDotnewDotkeyRoute =
  InfrastructureCloudaccountsDotnewDotkeyRouteImport.update({
    id: "/infrastructure/cloudaccounts/new/key",
    path: "/infrastructure/cloudaccounts/new/key",
    getParentRoute: () => consoleOrgRoute,
  } as any);
const InfrastructureCloudaccountsDotnewDotkubernetesRoute =
  InfrastructureCloudaccountsDotnewDotkubernetesRouteImport.update({
    id: "/infrastructure/cloudaccounts/new/kubernetes",
    path: "/infrastructure/cloudaccounts/new/kubernetes",
    getParentRoute: () => consoleOrgRoute,
  } as any);
const InfrastructureCloudaccountsDotnewDotazure_DotcallbackRoute =
  InfrastructureCloudaccountsDotnewDotazure_DotcallbackRouteImport.update({
    id: "/infrastructure/cloudaccounts/new/azure_/callback",
    path: "/infrastructure/cloudaccounts/new/azure/callback",
    getParentRoute: () => consoleOrgRoute,
  } as any);
const InfrastructureCloudaccountsDotnewDotgcp_DotcallbackRoute =
  InfrastructureCloudaccountsDotnewDotgcp_DotcallbackRouteImport.update({
    id: "/infrastructure/cloudaccounts/new/gcp_/callback",
    path: "/infrastructure/cloudaccounts/new/gcp/callback",
    getParentRoute: () => consoleOrgRoute,
  } as any);

export interface FileRoutesByFullPath {
  "/": typeof consoleIndexRoute;
  "/forgot-password": typeof ForgotPasswordRoute;
  "/reset-password": typeof ResetPasswordRoute;
  "/sign-in": typeof SignInRoute;
  "/sign-up": typeof SignUpRoute;
  "/verify-email": typeof VerifyEmailRoute;
  "/$org": typeof consoleOrgRouteWithChildren;
  "/account": typeof consoleAccountRouteWithChildren;
  "/mfa": typeof MfaRoute;
  "/moved": typeof MovedRoute;
  "/onboarding": typeof OnboardingRoute;
  "/reserved-compute": typeof marketplaceWorkspaceRouteWithChildren;
  "/auth/callback": typeof AuthDotcallbackRoute;
  "/marketplace": typeof marketplaceIndexRoute;
  "/$org/": typeof consoleOrgIndexRoute;
  "/$org/$project": typeof consoleProjectRouteWithChildren;
  "/account/privacy": typeof PrivacyRoute;
  "/account/profile": typeof ProfileRoute;
  "/account/security": typeof SecurityRoute;
  "/account/sshkeys": typeof SshkeysRoute;
  "/cli-auth/device": typeof CliAuthDotdeviceRoute;
  "/invite/$token": typeof InviteDottokenRoute;
  "/marketplace/$marketOrg": typeof marketplaceOrgRoute;
  "/oauth/consent": typeof OauthDotconsentRoute;
  "/reserved-compute/$marketView": typeof marketplaceViewRoute;
  "/account/": typeof IndexRoute;
  "/cli-auth/": typeof CliAuthDotindexRoute;
  "/$org/$project/": typeof consoleProjectIndexRoute;
  "/$org/$project/assets": typeof AssetsRoute;
  "/$org/$project/compute": typeof ComputeRoute;
  "/$org/$project/overview": typeof OverviewRoute;
  "/$org/$project/runs": typeof RunsRoute;
  "/$org/$project/ui-catalog": typeof UiCatalogRoute;
  "/$org/billing/$tab": typeof BillingDottabRoute;
  "/$org/integrations/mcp": typeof IntegrationsMcpRoute;
  "/$org/settings/apikeys": typeof SettingsApikeysRoute;
  "/$org/settings/audit": typeof SettingsAuditRoute;
  "/$org/settings/compute": typeof SettingsComputeRoute;
  "/$org/settings/general": typeof SettingsGeneralRoute;
  "/$org/settings/invites": typeof SettingsInvitesRoute;
  "/$org/settings/members": typeof SettingsMembersRoute;
  "/$org/settings/quotas": typeof SettingsQuotasRoute;
  "/$org/spot/settings": typeof SpotDotsettingsRoute;
  "/$org/spot/usage": typeof SpotDotusageRoute;
  "/$org/team/domains": typeof TeamDomainsRoute;
  "/$org/team/invites": typeof TeamInvitesRoute;
  "/$org/team/members": typeof TeamMembersRoute;
  "/$org/team/projects": typeof TeamProjectsRoute;
  "/$org/billing/": typeof BillingDotindexRoute;
  "/$org/integrations/": typeof IntegrationsIndexRoute;
  "/$org/settings/": typeof SettingsIndexRoute;
  "/$org/spot/": typeof SpotDotindexRoute;
  "/$org/team/": typeof TeamIndexRoute;
  "/$org/$project/apps/$name": typeof AppsDotnameRoute;
  "/$org/$project/connections/$name": typeof ConnectionsNameRoute;
  "/$org/$project/connections/new": typeof ConnectionsNewRoute;
  "/$org/$project/environments/$name": typeof EnvironmentsDotnameRoute;
  "/$org/$project/inferenceendpoints/new": typeof InferenceendpointsDotnewRoute;
  "/$org/$project/instances/new": typeof InstancesDotnewRoute;
  "/$org/$project/jobs/new": typeof JobsDotnewRoute;
  "/$org/$project/pools/new": typeof PoolsNewRoute;
  "/$org/$project/reservedhosts/requests": typeof ReservedhostsDotrequestsRoute;
  "/$org/$project/sandboxes/new": typeof SandboxesDotnewRoute;
  "/$org/$project/secrets/$name": typeof SecretsDotnameRoute;
  "/$org/$project/serviceaccounts/$name": typeof ServiceaccountsNameRoute;
  "/$org/$project/trainingruntimes/$name": typeof TrainingruntimesDotnameRoute;
  "/$org/$project/workspaces/new": typeof WorkspacesDotnewRoute;
  "/$org/billing/budgets/$name": typeof BillingDotbudgetsDotnameRoute;
  "/$org/infrastructure/cloudaccounts/$name": typeof InfrastructureCloudaccountsDotnameRoute;
  "/$org/infrastructure/nodes/$name": typeof InfrastructureNodesDotnameRoute;
  "/$org/settings/webhooks/$name": typeof SettingsWebhooksDotnameRoute;
  "/$org/$project/agents/": typeof AgentsDotindexRoute;
  "/$org/$project/connections/": typeof ConnectionsIndexRoute;
  "/$org/$project/environments/": typeof EnvironmentsDotindexRoute;
  "/$org/$project/functions/": typeof FunctionsDotindexRoute;
  "/$org/$project/images/": typeof ImagesDotindexRoute;
  "/$org/$project/inference/": typeof InferenceDotindexRoute;
  "/$org/$project/instances/": typeof InstancesDotindexRoute;
  "/$org/$project/pools/": typeof PoolsIndexRoute;
  "/$org/$project/reservedhosts/": typeof ReservedhostsDotindexRoute;
  "/$org/$project/sandboxes/": typeof SandboxesDotindexRoute;
  "/$org/$project/secrets/": typeof SecretsDotindexRoute;
  "/$org/$project/serviceaccounts/": typeof ServiceaccountsIndexRoute;
  "/$org/$project/trainingjobs/": typeof TrainingjobsDotindexRoute;
  "/$org/$project/volumes/": typeof VolumesDotindexRoute;
  "/$org/$project/workspaces/": typeof WorkspacesDotindexRoute;
  "/$org/infrastructure/cloudaccounts/": typeof InfrastructureCloudaccountsDotindexRoute;
  "/$org/infrastructure/nodes/": typeof InfrastructureNodesDotindexRoute;
  "/$org/settings/webhooks/": typeof SettingsWebhooksDotindexRoute;
  "/$org/$project/agentgroups/$name/$tab": typeof AgentgroupsDotnameDottabRoute;
  "/$org/$project/agentruns/$name/$tab": typeof AgentrunsDotnameDottabRoute;
  "/$org/$project/agents/$name/$tab": typeof AgentsDotnameDottabRoute;
  "/$org/$project/functions/$name/$tab": typeof FunctionsDotnameDottabRoute;
  "/$org/$project/images/$name/$tab": typeof ImagesDotnameDottabRoute;
  "/$org/$project/inferenceendpoints/$name/$tab": typeof InferenceendpointsDotnameDottabRoute;
  "/$org/$project/instances/$name/$tab": typeof InstancesDotnameDottabRoute;
  "/$org/$project/jobs/$name/$tab": typeof JobsDotnameDottabRoute;
  "/$org/$project/pipelines/$name/$tab": typeof PipelinesDotnameDottabRoute;
  "/$org/$project/pools/$name/$tab": typeof PoolsNameDottabRoute;
  "/$org/$project/reservedhosts/$name/$tab": typeof ReservedhostsDotnameDottabRoute;
  "/$org/$project/sandboxes/$name/$tab": typeof SandboxesDotnameDottabRoute;
  "/$org/$project/sweeps/$name/$tab": typeof SweepsDotnameDottabRoute;
  "/$org/$project/trainingjobs/$name/$tab": typeof TrainingjobsDotnameDottabRoute;
  "/$org/$project/volumes/$name/$tab": typeof VolumesDotnameDottabRoute;
  "/$org/$project/workspaces/$name/$tab": typeof WorkspacesDotnameDottabRoute;
  "/$org/infrastructure/cloudaccounts/new/aws": typeof InfrastructureCloudaccountsDotnewDotawsRoute;
  "/$org/infrastructure/cloudaccounts/new/azure": typeof InfrastructureCloudaccountsDotnewDotazureRoute;
  "/$org/infrastructure/cloudaccounts/new/gcp": typeof InfrastructureCloudaccountsDotnewDotgcpRoute;
  "/$org/infrastructure/cloudaccounts/new/key": typeof InfrastructureCloudaccountsDotnewDotkeyRoute;
  "/$org/infrastructure/cloudaccounts/new/kubernetes": typeof InfrastructureCloudaccountsDotnewDotkubernetesRoute;
  "/$org/$project/images/$name/": typeof ImagesDotnameDotindexRoute;
  "/$org/$project/inferenceendpoints/$name/": typeof InferenceendpointsDotnameDotindexRoute;
  "/$org/$project/pools/$name/": typeof PoolsNameDotindexRoute;
  "/$org/$project/volumes/$name/": typeof VolumesDotnameDotindexRoute;
  "/$org/infrastructure/cloudaccounts/new/azure/callback": typeof InfrastructureCloudaccountsDotnewDotazure_DotcallbackRoute;
  "/$org/infrastructure/cloudaccounts/new/gcp/callback": typeof InfrastructureCloudaccountsDotnewDotgcp_DotcallbackRoute;
}
export interface FileRoutesByTo {
  "/": typeof consoleIndexRoute;
  "/forgot-password": typeof ForgotPasswordRoute;
  "/reset-password": typeof ResetPasswordRoute;
  "/sign-in": typeof SignInRoute;
  "/sign-up": typeof SignUpRoute;
  "/verify-email": typeof VerifyEmailRoute;
  "/mfa": typeof MfaRoute;
  "/moved": typeof MovedRoute;
  "/onboarding": typeof OnboardingRoute;
  "/reserved-compute": typeof marketplaceWorkspaceRouteWithChildren;
  "/auth/callback": typeof AuthDotcallbackRoute;
  "/marketplace": typeof marketplaceIndexRoute;
  "/$org": typeof consoleOrgIndexRoute;
  "/account/privacy": typeof PrivacyRoute;
  "/account/profile": typeof ProfileRoute;
  "/account/security": typeof SecurityRoute;
  "/account/sshkeys": typeof SshkeysRoute;
  "/cli-auth/device": typeof CliAuthDotdeviceRoute;
  "/invite/$token": typeof InviteDottokenRoute;
  "/marketplace/$marketOrg": typeof marketplaceOrgRoute;
  "/oauth/consent": typeof OauthDotconsentRoute;
  "/reserved-compute/$marketView": typeof marketplaceViewRoute;
  "/account": typeof IndexRoute;
  "/cli-auth": typeof CliAuthDotindexRoute;
  "/$org/$project": typeof consoleProjectIndexRoute;
  "/$org/$project/assets": typeof AssetsRoute;
  "/$org/$project/compute": typeof ComputeRoute;
  "/$org/$project/overview": typeof OverviewRoute;
  "/$org/$project/runs": typeof RunsRoute;
  "/$org/$project/ui-catalog": typeof UiCatalogRoute;
  "/$org/billing/$tab": typeof BillingDottabRoute;
  "/$org/integrations/mcp": typeof IntegrationsMcpRoute;
  "/$org/settings/apikeys": typeof SettingsApikeysRoute;
  "/$org/settings/audit": typeof SettingsAuditRoute;
  "/$org/settings/compute": typeof SettingsComputeRoute;
  "/$org/settings/general": typeof SettingsGeneralRoute;
  "/$org/settings/invites": typeof SettingsInvitesRoute;
  "/$org/settings/members": typeof SettingsMembersRoute;
  "/$org/settings/quotas": typeof SettingsQuotasRoute;
  "/$org/spot/settings": typeof SpotDotsettingsRoute;
  "/$org/spot/usage": typeof SpotDotusageRoute;
  "/$org/team/domains": typeof TeamDomainsRoute;
  "/$org/team/invites": typeof TeamInvitesRoute;
  "/$org/team/members": typeof TeamMembersRoute;
  "/$org/team/projects": typeof TeamProjectsRoute;
  "/$org/billing": typeof BillingDotindexRoute;
  "/$org/integrations": typeof IntegrationsIndexRoute;
  "/$org/settings": typeof SettingsIndexRoute;
  "/$org/spot": typeof SpotDotindexRoute;
  "/$org/team": typeof TeamIndexRoute;
  "/$org/$project/apps/$name": typeof AppsDotnameRoute;
  "/$org/$project/connections/$name": typeof ConnectionsNameRoute;
  "/$org/$project/connections/new": typeof ConnectionsNewRoute;
  "/$org/$project/environments/$name": typeof EnvironmentsDotnameRoute;
  "/$org/$project/inferenceendpoints/new": typeof InferenceendpointsDotnewRoute;
  "/$org/$project/instances/new": typeof InstancesDotnewRoute;
  "/$org/$project/jobs/new": typeof JobsDotnewRoute;
  "/$org/$project/pools/new": typeof PoolsNewRoute;
  "/$org/$project/reservedhosts/requests": typeof ReservedhostsDotrequestsRoute;
  "/$org/$project/sandboxes/new": typeof SandboxesDotnewRoute;
  "/$org/$project/secrets/$name": typeof SecretsDotnameRoute;
  "/$org/$project/serviceaccounts/$name": typeof ServiceaccountsNameRoute;
  "/$org/$project/trainingruntimes/$name": typeof TrainingruntimesDotnameRoute;
  "/$org/$project/workspaces/new": typeof WorkspacesDotnewRoute;
  "/$org/billing/budgets/$name": typeof BillingDotbudgetsDotnameRoute;
  "/$org/infrastructure/cloudaccounts/$name": typeof InfrastructureCloudaccountsDotnameRoute;
  "/$org/infrastructure/nodes/$name": typeof InfrastructureNodesDotnameRoute;
  "/$org/settings/webhooks/$name": typeof SettingsWebhooksDotnameRoute;
  "/$org/$project/agents": typeof AgentsDotindexRoute;
  "/$org/$project/connections": typeof ConnectionsIndexRoute;
  "/$org/$project/environments": typeof EnvironmentsDotindexRoute;
  "/$org/$project/functions": typeof FunctionsDotindexRoute;
  "/$org/$project/images": typeof ImagesDotindexRoute;
  "/$org/$project/inference": typeof InferenceDotindexRoute;
  "/$org/$project/instances": typeof InstancesDotindexRoute;
  "/$org/$project/pools": typeof PoolsIndexRoute;
  "/$org/$project/reservedhosts": typeof ReservedhostsDotindexRoute;
  "/$org/$project/sandboxes": typeof SandboxesDotindexRoute;
  "/$org/$project/secrets": typeof SecretsDotindexRoute;
  "/$org/$project/serviceaccounts": typeof ServiceaccountsIndexRoute;
  "/$org/$project/trainingjobs": typeof TrainingjobsDotindexRoute;
  "/$org/$project/volumes": typeof VolumesDotindexRoute;
  "/$org/$project/workspaces": typeof WorkspacesDotindexRoute;
  "/$org/infrastructure/cloudaccounts": typeof InfrastructureCloudaccountsDotindexRoute;
  "/$org/infrastructure/nodes": typeof InfrastructureNodesDotindexRoute;
  "/$org/settings/webhooks": typeof SettingsWebhooksDotindexRoute;
  "/$org/$project/agentgroups/$name/$tab": typeof AgentgroupsDotnameDottabRoute;
  "/$org/$project/agentruns/$name/$tab": typeof AgentrunsDotnameDottabRoute;
  "/$org/$project/agents/$name/$tab": typeof AgentsDotnameDottabRoute;
  "/$org/$project/functions/$name/$tab": typeof FunctionsDotnameDottabRoute;
  "/$org/$project/images/$name/$tab": typeof ImagesDotnameDottabRoute;
  "/$org/$project/inferenceendpoints/$name/$tab": typeof InferenceendpointsDotnameDottabRoute;
  "/$org/$project/instances/$name/$tab": typeof InstancesDotnameDottabRoute;
  "/$org/$project/jobs/$name/$tab": typeof JobsDotnameDottabRoute;
  "/$org/$project/pipelines/$name/$tab": typeof PipelinesDotnameDottabRoute;
  "/$org/$project/pools/$name/$tab": typeof PoolsNameDottabRoute;
  "/$org/$project/reservedhosts/$name/$tab": typeof ReservedhostsDotnameDottabRoute;
  "/$org/$project/sandboxes/$name/$tab": typeof SandboxesDotnameDottabRoute;
  "/$org/$project/sweeps/$name/$tab": typeof SweepsDotnameDottabRoute;
  "/$org/$project/trainingjobs/$name/$tab": typeof TrainingjobsDotnameDottabRoute;
  "/$org/$project/volumes/$name/$tab": typeof VolumesDotnameDottabRoute;
  "/$org/$project/workspaces/$name/$tab": typeof WorkspacesDotnameDottabRoute;
  "/$org/infrastructure/cloudaccounts/new/aws": typeof InfrastructureCloudaccountsDotnewDotawsRoute;
  "/$org/infrastructure/cloudaccounts/new/azure": typeof InfrastructureCloudaccountsDotnewDotazureRoute;
  "/$org/infrastructure/cloudaccounts/new/gcp": typeof InfrastructureCloudaccountsDotnewDotgcpRoute;
  "/$org/infrastructure/cloudaccounts/new/key": typeof InfrastructureCloudaccountsDotnewDotkeyRoute;
  "/$org/infrastructure/cloudaccounts/new/kubernetes": typeof InfrastructureCloudaccountsDotnewDotkubernetesRoute;
  "/$org/$project/images/$name": typeof ImagesDotnameDotindexRoute;
  "/$org/$project/inferenceendpoints/$name": typeof InferenceendpointsDotnameDotindexRoute;
  "/$org/$project/pools/$name": typeof PoolsNameDotindexRoute;
  "/$org/$project/volumes/$name": typeof VolumesDotnameDotindexRoute;
  "/$org/infrastructure/cloudaccounts/new/azure/callback": typeof InfrastructureCloudaccountsDotnewDotazure_DotcallbackRoute;
  "/$org/infrastructure/cloudaccounts/new/gcp/callback": typeof InfrastructureCloudaccountsDotnewDotgcp_DotcallbackRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  "/": typeof consoleIndexRoute;
  "/_authed": typeof consoleAuthedRouteWithChildren;
  "/forgot-password": typeof ForgotPasswordRoute;
  "/reset-password": typeof ResetPasswordRoute;
  "/sign-in": typeof SignInRoute;
  "/sign-up": typeof SignUpRoute;
  "/verify-email": typeof VerifyEmailRoute;
  "/_authed/$org": typeof consoleOrgRouteWithChildren;
  "/_authed/account": typeof consoleAccountRouteWithChildren;
  "/_authed/mfa": typeof MfaRoute;
  "/_authed/moved": typeof MovedRoute;
  "/_authed/onboarding": typeof OnboardingRoute;
  "/_authed/reserved-compute": typeof marketplaceWorkspaceRouteWithChildren;
  "/auth/callback": typeof AuthDotcallbackRoute;
  "/_authed/marketplace": typeof marketplaceIndexRoute;
  "/_authed/$org/": typeof consoleOrgIndexRoute;
  "/_authed/$org/$project": typeof consoleProjectRouteWithChildren;
  "/_authed/account/privacy": typeof PrivacyRoute;
  "/_authed/account/profile": typeof ProfileRoute;
  "/_authed/account/security": typeof SecurityRoute;
  "/_authed/account/sshkeys": typeof SshkeysRoute;
  "/_authed/cli-auth/device": typeof CliAuthDotdeviceRoute;
  "/_authed/invite/$token": typeof InviteDottokenRoute;
  "/_authed/marketplace/$marketOrg": typeof marketplaceOrgRoute;
  "/_authed/oauth/consent": typeof OauthDotconsentRoute;
  "/_authed/reserved-compute/$marketView": typeof marketplaceViewRoute;
  "/_authed/account/": typeof IndexRoute;
  "/_authed/cli-auth/": typeof CliAuthDotindexRoute;
  "/_authed/$org/$project/": typeof consoleProjectIndexRoute;
  "/_authed/$org/$project/assets": typeof AssetsRoute;
  "/_authed/$org/$project/compute": typeof ComputeRoute;
  "/_authed/$org/$project/overview": typeof OverviewRoute;
  "/_authed/$org/$project/runs": typeof RunsRoute;
  "/_authed/$org/$project/ui-catalog": typeof UiCatalogRoute;
  "/_authed/$org/billing/$tab": typeof BillingDottabRoute;
  "/_authed/$org/integrations/mcp": typeof IntegrationsMcpRoute;
  "/_authed/$org/settings/apikeys": typeof SettingsApikeysRoute;
  "/_authed/$org/settings/audit": typeof SettingsAuditRoute;
  "/_authed/$org/settings/compute": typeof SettingsComputeRoute;
  "/_authed/$org/settings/general": typeof SettingsGeneralRoute;
  "/_authed/$org/settings/invites": typeof SettingsInvitesRoute;
  "/_authed/$org/settings/members": typeof SettingsMembersRoute;
  "/_authed/$org/settings/quotas": typeof SettingsQuotasRoute;
  "/_authed/$org/spot/settings": typeof SpotDotsettingsRoute;
  "/_authed/$org/spot/usage": typeof SpotDotusageRoute;
  "/_authed/$org/team/domains": typeof TeamDomainsRoute;
  "/_authed/$org/team/invites": typeof TeamInvitesRoute;
  "/_authed/$org/team/members": typeof TeamMembersRoute;
  "/_authed/$org/team/projects": typeof TeamProjectsRoute;
  "/_authed/$org/billing/": typeof BillingDotindexRoute;
  "/_authed/$org/integrations/": typeof IntegrationsIndexRoute;
  "/_authed/$org/settings/": typeof SettingsIndexRoute;
  "/_authed/$org/spot/": typeof SpotDotindexRoute;
  "/_authed/$org/team/": typeof TeamIndexRoute;
  "/_authed/$org/$project/apps/$name": typeof AppsDotnameRoute;
  "/_authed/$org/$project/connections/$name": typeof ConnectionsNameRoute;
  "/_authed/$org/$project/connections/new": typeof ConnectionsNewRoute;
  "/_authed/$org/$project/environments/$name": typeof EnvironmentsDotnameRoute;
  "/_authed/$org/$project/inferenceendpoints/new": typeof InferenceendpointsDotnewRoute;
  "/_authed/$org/$project/instances/new": typeof InstancesDotnewRoute;
  "/_authed/$org/$project/jobs/new": typeof JobsDotnewRoute;
  "/_authed/$org/$project/pools/new": typeof PoolsNewRoute;
  "/_authed/$org/$project/reservedhosts/requests": typeof ReservedhostsDotrequestsRoute;
  "/_authed/$org/$project/sandboxes/new": typeof SandboxesDotnewRoute;
  "/_authed/$org/$project/secrets/$name": typeof SecretsDotnameRoute;
  "/_authed/$org/$project/serviceaccounts/$name": typeof ServiceaccountsNameRoute;
  "/_authed/$org/$project/trainingruntimes/$name": typeof TrainingruntimesDotnameRoute;
  "/_authed/$org/$project/workspaces/new": typeof WorkspacesDotnewRoute;
  "/_authed/$org/billing/budgets/$name": typeof BillingDotbudgetsDotnameRoute;
  "/_authed/$org/infrastructure/cloudaccounts/$name": typeof InfrastructureCloudaccountsDotnameRoute;
  "/_authed/$org/infrastructure/nodes/$name": typeof InfrastructureNodesDotnameRoute;
  "/_authed/$org/settings/webhooks/$name": typeof SettingsWebhooksDotnameRoute;
  "/_authed/$org/$project/agents/": typeof AgentsDotindexRoute;
  "/_authed/$org/$project/connections/": typeof ConnectionsIndexRoute;
  "/_authed/$org/$project/environments/": typeof EnvironmentsDotindexRoute;
  "/_authed/$org/$project/functions/": typeof FunctionsDotindexRoute;
  "/_authed/$org/$project/images/": typeof ImagesDotindexRoute;
  "/_authed/$org/$project/inference/": typeof InferenceDotindexRoute;
  "/_authed/$org/$project/instances/": typeof InstancesDotindexRoute;
  "/_authed/$org/$project/pools/": typeof PoolsIndexRoute;
  "/_authed/$org/$project/reservedhosts/": typeof ReservedhostsDotindexRoute;
  "/_authed/$org/$project/sandboxes/": typeof SandboxesDotindexRoute;
  "/_authed/$org/$project/secrets/": typeof SecretsDotindexRoute;
  "/_authed/$org/$project/serviceaccounts/": typeof ServiceaccountsIndexRoute;
  "/_authed/$org/$project/trainingjobs/": typeof TrainingjobsDotindexRoute;
  "/_authed/$org/$project/volumes/": typeof VolumesDotindexRoute;
  "/_authed/$org/$project/workspaces/": typeof WorkspacesDotindexRoute;
  "/_authed/$org/infrastructure/cloudaccounts/": typeof InfrastructureCloudaccountsDotindexRoute;
  "/_authed/$org/infrastructure/nodes/": typeof InfrastructureNodesDotindexRoute;
  "/_authed/$org/settings/webhooks/": typeof SettingsWebhooksDotindexRoute;
  "/_authed/$org/$project/agentgroups/$name/$tab": typeof AgentgroupsDotnameDottabRoute;
  "/_authed/$org/$project/agentruns/$name/$tab": typeof AgentrunsDotnameDottabRoute;
  "/_authed/$org/$project/agents/$name/$tab": typeof AgentsDotnameDottabRoute;
  "/_authed/$org/$project/functions/$name/$tab": typeof FunctionsDotnameDottabRoute;
  "/_authed/$org/$project/images/$name/$tab": typeof ImagesDotnameDottabRoute;
  "/_authed/$org/$project/inferenceendpoints/$name/$tab": typeof InferenceendpointsDotnameDottabRoute;
  "/_authed/$org/$project/instances/$name/$tab": typeof InstancesDotnameDottabRoute;
  "/_authed/$org/$project/jobs/$name/$tab": typeof JobsDotnameDottabRoute;
  "/_authed/$org/$project/pipelines/$name/$tab": typeof PipelinesDotnameDottabRoute;
  "/_authed/$org/$project/pools/$name/$tab": typeof PoolsNameDottabRoute;
  "/_authed/$org/$project/reservedhosts/$name/$tab": typeof ReservedhostsDotnameDottabRoute;
  "/_authed/$org/$project/sandboxes/$name/$tab": typeof SandboxesDotnameDottabRoute;
  "/_authed/$org/$project/sweeps/$name/$tab": typeof SweepsDotnameDottabRoute;
  "/_authed/$org/$project/trainingjobs/$name/$tab": typeof TrainingjobsDotnameDottabRoute;
  "/_authed/$org/$project/volumes/$name/$tab": typeof VolumesDotnameDottabRoute;
  "/_authed/$org/$project/workspaces/$name/$tab": typeof WorkspacesDotnameDottabRoute;
  "/_authed/$org/infrastructure/cloudaccounts/new/aws": typeof InfrastructureCloudaccountsDotnewDotawsRoute;
  "/_authed/$org/infrastructure/cloudaccounts/new/azure": typeof InfrastructureCloudaccountsDotnewDotazureRoute;
  "/_authed/$org/infrastructure/cloudaccounts/new/gcp": typeof InfrastructureCloudaccountsDotnewDotgcpRoute;
  "/_authed/$org/infrastructure/cloudaccounts/new/key": typeof InfrastructureCloudaccountsDotnewDotkeyRoute;
  "/_authed/$org/infrastructure/cloudaccounts/new/kubernetes": typeof InfrastructureCloudaccountsDotnewDotkubernetesRoute;
  "/_authed/$org/$project/images/$name/": typeof ImagesDotnameDotindexRoute;
  "/_authed/$org/$project/inferenceendpoints/$name/": typeof InferenceendpointsDotnameDotindexRoute;
  "/_authed/$org/$project/pools/$name/": typeof PoolsNameDotindexRoute;
  "/_authed/$org/$project/volumes/$name/": typeof VolumesDotnameDotindexRoute;
  "/_authed/$org/infrastructure/cloudaccounts/new/azure_/callback": typeof InfrastructureCloudaccountsDotnewDotazure_DotcallbackRoute;
  "/_authed/$org/infrastructure/cloudaccounts/new/gcp_/callback": typeof InfrastructureCloudaccountsDotnewDotgcp_DotcallbackRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | "/"
    | "/forgot-password"
    | "/reset-password"
    | "/sign-in"
    | "/sign-up"
    | "/verify-email"
    | "/$org"
    | "/account"
    | "/mfa"
    | "/moved"
    | "/onboarding"
    | "/reserved-compute"
    | "/auth/callback"
    | "/marketplace"
    | "/$org/"
    | "/$org/$project"
    | "/account/privacy"
    | "/account/profile"
    | "/account/security"
    | "/account/sshkeys"
    | "/cli-auth/device"
    | "/invite/$token"
    | "/marketplace/$marketOrg"
    | "/oauth/consent"
    | "/reserved-compute/$marketView"
    | "/account/"
    | "/cli-auth/"
    | "/$org/$project/"
    | "/$org/$project/assets"
    | "/$org/$project/compute"
    | "/$org/$project/overview"
    | "/$org/$project/runs"
    | "/$org/$project/ui-catalog"
    | "/$org/billing/$tab"
    | "/$org/integrations/mcp"
    | "/$org/settings/apikeys"
    | "/$org/settings/audit"
    | "/$org/settings/compute"
    | "/$org/settings/general"
    | "/$org/settings/invites"
    | "/$org/settings/members"
    | "/$org/settings/quotas"
    | "/$org/spot/settings"
    | "/$org/spot/usage"
    | "/$org/team/domains"
    | "/$org/team/invites"
    | "/$org/team/members"
    | "/$org/team/projects"
    | "/$org/billing/"
    | "/$org/integrations/"
    | "/$org/settings/"
    | "/$org/spot/"
    | "/$org/team/"
    | "/$org/$project/apps/$name"
    | "/$org/$project/connections/$name"
    | "/$org/$project/connections/new"
    | "/$org/$project/environments/$name"
    | "/$org/$project/inferenceendpoints/new"
    | "/$org/$project/instances/new"
    | "/$org/$project/jobs/new"
    | "/$org/$project/pools/new"
    | "/$org/$project/reservedhosts/requests"
    | "/$org/$project/sandboxes/new"
    | "/$org/$project/secrets/$name"
    | "/$org/$project/serviceaccounts/$name"
    | "/$org/$project/trainingruntimes/$name"
    | "/$org/$project/workspaces/new"
    | "/$org/billing/budgets/$name"
    | "/$org/infrastructure/cloudaccounts/$name"
    | "/$org/infrastructure/nodes/$name"
    | "/$org/settings/webhooks/$name"
    | "/$org/$project/agents/"
    | "/$org/$project/connections/"
    | "/$org/$project/environments/"
    | "/$org/$project/functions/"
    | "/$org/$project/images/"
    | "/$org/$project/inference/"
    | "/$org/$project/instances/"
    | "/$org/$project/pools/"
    | "/$org/$project/reservedhosts/"
    | "/$org/$project/sandboxes/"
    | "/$org/$project/secrets/"
    | "/$org/$project/serviceaccounts/"
    | "/$org/$project/trainingjobs/"
    | "/$org/$project/volumes/"
    | "/$org/$project/workspaces/"
    | "/$org/infrastructure/cloudaccounts/"
    | "/$org/infrastructure/nodes/"
    | "/$org/settings/webhooks/"
    | "/$org/$project/agentgroups/$name/$tab"
    | "/$org/$project/agentruns/$name/$tab"
    | "/$org/$project/agents/$name/$tab"
    | "/$org/$project/functions/$name/$tab"
    | "/$org/$project/images/$name/$tab"
    | "/$org/$project/inferenceendpoints/$name/$tab"
    | "/$org/$project/instances/$name/$tab"
    | "/$org/$project/jobs/$name/$tab"
    | "/$org/$project/pipelines/$name/$tab"
    | "/$org/$project/pools/$name/$tab"
    | "/$org/$project/reservedhosts/$name/$tab"
    | "/$org/$project/sandboxes/$name/$tab"
    | "/$org/$project/sweeps/$name/$tab"
    | "/$org/$project/trainingjobs/$name/$tab"
    | "/$org/$project/volumes/$name/$tab"
    | "/$org/$project/workspaces/$name/$tab"
    | "/$org/infrastructure/cloudaccounts/new/aws"
    | "/$org/infrastructure/cloudaccounts/new/azure"
    | "/$org/infrastructure/cloudaccounts/new/gcp"
    | "/$org/infrastructure/cloudaccounts/new/key"
    | "/$org/infrastructure/cloudaccounts/new/kubernetes"
    | "/$org/$project/images/$name/"
    | "/$org/$project/inferenceendpoints/$name/"
    | "/$org/$project/pools/$name/"
    | "/$org/$project/volumes/$name/"
    | "/$org/infrastructure/cloudaccounts/new/azure/callback"
    | "/$org/infrastructure/cloudaccounts/new/gcp/callback";
  fileRoutesByTo: FileRoutesByTo;
  to:
    | "/"
    | "/forgot-password"
    | "/reset-password"
    | "/sign-in"
    | "/sign-up"
    | "/verify-email"
    | "/mfa"
    | "/moved"
    | "/onboarding"
    | "/reserved-compute"
    | "/auth/callback"
    | "/marketplace"
    | "/$org"
    | "/account/privacy"
    | "/account/profile"
    | "/account/security"
    | "/account/sshkeys"
    | "/cli-auth/device"
    | "/invite/$token"
    | "/marketplace/$marketOrg"
    | "/oauth/consent"
    | "/reserved-compute/$marketView"
    | "/account"
    | "/cli-auth"
    | "/$org/$project"
    | "/$org/$project/assets"
    | "/$org/$project/compute"
    | "/$org/$project/overview"
    | "/$org/$project/runs"
    | "/$org/$project/ui-catalog"
    | "/$org/billing/$tab"
    | "/$org/integrations/mcp"
    | "/$org/settings/apikeys"
    | "/$org/settings/audit"
    | "/$org/settings/compute"
    | "/$org/settings/general"
    | "/$org/settings/invites"
    | "/$org/settings/members"
    | "/$org/settings/quotas"
    | "/$org/spot/settings"
    | "/$org/spot/usage"
    | "/$org/team/domains"
    | "/$org/team/invites"
    | "/$org/team/members"
    | "/$org/team/projects"
    | "/$org/billing"
    | "/$org/integrations"
    | "/$org/settings"
    | "/$org/spot"
    | "/$org/team"
    | "/$org/$project/apps/$name"
    | "/$org/$project/connections/$name"
    | "/$org/$project/connections/new"
    | "/$org/$project/environments/$name"
    | "/$org/$project/inferenceendpoints/new"
    | "/$org/$project/instances/new"
    | "/$org/$project/jobs/new"
    | "/$org/$project/pools/new"
    | "/$org/$project/reservedhosts/requests"
    | "/$org/$project/sandboxes/new"
    | "/$org/$project/secrets/$name"
    | "/$org/$project/serviceaccounts/$name"
    | "/$org/$project/trainingruntimes/$name"
    | "/$org/$project/workspaces/new"
    | "/$org/billing/budgets/$name"
    | "/$org/infrastructure/cloudaccounts/$name"
    | "/$org/infrastructure/nodes/$name"
    | "/$org/settings/webhooks/$name"
    | "/$org/$project/agents"
    | "/$org/$project/connections"
    | "/$org/$project/environments"
    | "/$org/$project/functions"
    | "/$org/$project/images"
    | "/$org/$project/inference"
    | "/$org/$project/instances"
    | "/$org/$project/pools"
    | "/$org/$project/reservedhosts"
    | "/$org/$project/sandboxes"
    | "/$org/$project/secrets"
    | "/$org/$project/serviceaccounts"
    | "/$org/$project/trainingjobs"
    | "/$org/$project/volumes"
    | "/$org/$project/workspaces"
    | "/$org/infrastructure/cloudaccounts"
    | "/$org/infrastructure/nodes"
    | "/$org/settings/webhooks"
    | "/$org/$project/agentgroups/$name/$tab"
    | "/$org/$project/agentruns/$name/$tab"
    | "/$org/$project/agents/$name/$tab"
    | "/$org/$project/functions/$name/$tab"
    | "/$org/$project/images/$name/$tab"
    | "/$org/$project/inferenceendpoints/$name/$tab"
    | "/$org/$project/instances/$name/$tab"
    | "/$org/$project/jobs/$name/$tab"
    | "/$org/$project/pipelines/$name/$tab"
    | "/$org/$project/pools/$name/$tab"
    | "/$org/$project/reservedhosts/$name/$tab"
    | "/$org/$project/sandboxes/$name/$tab"
    | "/$org/$project/sweeps/$name/$tab"
    | "/$org/$project/trainingjobs/$name/$tab"
    | "/$org/$project/volumes/$name/$tab"
    | "/$org/$project/workspaces/$name/$tab"
    | "/$org/infrastructure/cloudaccounts/new/aws"
    | "/$org/infrastructure/cloudaccounts/new/azure"
    | "/$org/infrastructure/cloudaccounts/new/gcp"
    | "/$org/infrastructure/cloudaccounts/new/key"
    | "/$org/infrastructure/cloudaccounts/new/kubernetes"
    | "/$org/$project/images/$name"
    | "/$org/$project/inferenceendpoints/$name"
    | "/$org/$project/pools/$name"
    | "/$org/$project/volumes/$name"
    | "/$org/infrastructure/cloudaccounts/new/azure/callback"
    | "/$org/infrastructure/cloudaccounts/new/gcp/callback";
  id:
    | "__root__"
    | "/"
    | "/_authed"
    | "/forgot-password"
    | "/reset-password"
    | "/sign-in"
    | "/sign-up"
    | "/verify-email"
    | "/_authed/$org"
    | "/_authed/account"
    | "/_authed/mfa"
    | "/_authed/moved"
    | "/_authed/onboarding"
    | "/_authed/reserved-compute"
    | "/auth/callback"
    | "/_authed/marketplace"
    | "/_authed/$org/"
    | "/_authed/$org/$project"
    | "/_authed/account/privacy"
    | "/_authed/account/profile"
    | "/_authed/account/security"
    | "/_authed/account/sshkeys"
    | "/_authed/cli-auth/device"
    | "/_authed/invite/$token"
    | "/_authed/marketplace/$marketOrg"
    | "/_authed/oauth/consent"
    | "/_authed/reserved-compute/$marketView"
    | "/_authed/account/"
    | "/_authed/cli-auth/"
    | "/_authed/$org/$project/"
    | "/_authed/$org/$project/assets"
    | "/_authed/$org/$project/compute"
    | "/_authed/$org/$project/overview"
    | "/_authed/$org/$project/runs"
    | "/_authed/$org/$project/ui-catalog"
    | "/_authed/$org/billing/$tab"
    | "/_authed/$org/integrations/mcp"
    | "/_authed/$org/settings/apikeys"
    | "/_authed/$org/settings/audit"
    | "/_authed/$org/settings/compute"
    | "/_authed/$org/settings/general"
    | "/_authed/$org/settings/invites"
    | "/_authed/$org/settings/members"
    | "/_authed/$org/settings/quotas"
    | "/_authed/$org/spot/settings"
    | "/_authed/$org/spot/usage"
    | "/_authed/$org/team/domains"
    | "/_authed/$org/team/invites"
    | "/_authed/$org/team/members"
    | "/_authed/$org/team/projects"
    | "/_authed/$org/billing/"
    | "/_authed/$org/integrations/"
    | "/_authed/$org/settings/"
    | "/_authed/$org/spot/"
    | "/_authed/$org/team/"
    | "/_authed/$org/$project/apps/$name"
    | "/_authed/$org/$project/connections/$name"
    | "/_authed/$org/$project/connections/new"
    | "/_authed/$org/$project/environments/$name"
    | "/_authed/$org/$project/inferenceendpoints/new"
    | "/_authed/$org/$project/instances/new"
    | "/_authed/$org/$project/jobs/new"
    | "/_authed/$org/$project/pools/new"
    | "/_authed/$org/$project/reservedhosts/requests"
    | "/_authed/$org/$project/sandboxes/new"
    | "/_authed/$org/$project/secrets/$name"
    | "/_authed/$org/$project/serviceaccounts/$name"
    | "/_authed/$org/$project/trainingruntimes/$name"
    | "/_authed/$org/$project/workspaces/new"
    | "/_authed/$org/billing/budgets/$name"
    | "/_authed/$org/infrastructure/cloudaccounts/$name"
    | "/_authed/$org/infrastructure/nodes/$name"
    | "/_authed/$org/settings/webhooks/$name"
    | "/_authed/$org/$project/agents/"
    | "/_authed/$org/$project/connections/"
    | "/_authed/$org/$project/environments/"
    | "/_authed/$org/$project/functions/"
    | "/_authed/$org/$project/images/"
    | "/_authed/$org/$project/inference/"
    | "/_authed/$org/$project/instances/"
    | "/_authed/$org/$project/pools/"
    | "/_authed/$org/$project/reservedhosts/"
    | "/_authed/$org/$project/sandboxes/"
    | "/_authed/$org/$project/secrets/"
    | "/_authed/$org/$project/serviceaccounts/"
    | "/_authed/$org/$project/trainingjobs/"
    | "/_authed/$org/$project/volumes/"
    | "/_authed/$org/$project/workspaces/"
    | "/_authed/$org/infrastructure/cloudaccounts/"
    | "/_authed/$org/infrastructure/nodes/"
    | "/_authed/$org/settings/webhooks/"
    | "/_authed/$org/$project/agentgroups/$name/$tab"
    | "/_authed/$org/$project/agentruns/$name/$tab"
    | "/_authed/$org/$project/agents/$name/$tab"
    | "/_authed/$org/$project/functions/$name/$tab"
    | "/_authed/$org/$project/images/$name/$tab"
    | "/_authed/$org/$project/inferenceendpoints/$name/$tab"
    | "/_authed/$org/$project/instances/$name/$tab"
    | "/_authed/$org/$project/jobs/$name/$tab"
    | "/_authed/$org/$project/pipelines/$name/$tab"
    | "/_authed/$org/$project/pools/$name/$tab"
    | "/_authed/$org/$project/reservedhosts/$name/$tab"
    | "/_authed/$org/$project/sandboxes/$name/$tab"
    | "/_authed/$org/$project/sweeps/$name/$tab"
    | "/_authed/$org/$project/trainingjobs/$name/$tab"
    | "/_authed/$org/$project/volumes/$name/$tab"
    | "/_authed/$org/$project/workspaces/$name/$tab"
    | "/_authed/$org/infrastructure/cloudaccounts/new/aws"
    | "/_authed/$org/infrastructure/cloudaccounts/new/azure"
    | "/_authed/$org/infrastructure/cloudaccounts/new/gcp"
    | "/_authed/$org/infrastructure/cloudaccounts/new/key"
    | "/_authed/$org/infrastructure/cloudaccounts/new/kubernetes"
    | "/_authed/$org/$project/images/$name/"
    | "/_authed/$org/$project/inferenceendpoints/$name/"
    | "/_authed/$org/$project/pools/$name/"
    | "/_authed/$org/$project/volumes/$name/"
    | "/_authed/$org/infrastructure/cloudaccounts/new/azure_/callback"
    | "/_authed/$org/infrastructure/cloudaccounts/new/gcp_/callback";
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  consoleIndexRoute: typeof consoleIndexRoute;
  consoleAuthedRoute: typeof consoleAuthedRouteWithChildren;
  ForgotPasswordRoute: typeof ForgotPasswordRoute;
  ResetPasswordRoute: typeof ResetPasswordRoute;
  SignInRoute: typeof SignInRoute;
  SignUpRoute: typeof SignUpRoute;
  VerifyEmailRoute: typeof VerifyEmailRoute;
  AuthDotcallbackRoute: typeof AuthDotcallbackRoute;
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/": {
      id: "/";
      path: "/";
      fullPath: "/";
      preLoaderRoute: typeof consoleIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/_authed": {
      id: "/_authed";
      path: "";
      fullPath: "/";
      preLoaderRoute: typeof consoleAuthedRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/forgot-password": {
      id: "/forgot-password";
      path: "/forgot-password";
      fullPath: "/forgot-password";
      preLoaderRoute: typeof ForgotPasswordRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/reset-password": {
      id: "/reset-password";
      path: "/reset-password";
      fullPath: "/reset-password";
      preLoaderRoute: typeof ResetPasswordRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/sign-in": {
      id: "/sign-in";
      path: "/sign-in";
      fullPath: "/sign-in";
      preLoaderRoute: typeof SignInRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/sign-up": {
      id: "/sign-up";
      path: "/sign-up";
      fullPath: "/sign-up";
      preLoaderRoute: typeof SignUpRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/verify-email": {
      id: "/verify-email";
      path: "/verify-email";
      fullPath: "/verify-email";
      preLoaderRoute: typeof VerifyEmailRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/_authed/$org": {
      id: "/_authed/$org";
      path: "/$org";
      fullPath: "/$org";
      preLoaderRoute: typeof consoleOrgRouteImport;
      parentRoute: typeof consoleAuthedRoute;
    };
    "/_authed/account": {
      id: "/_authed/account";
      path: "/account";
      fullPath: "/account";
      preLoaderRoute: typeof consoleAccountRouteImport;
      parentRoute: typeof consoleAuthedRoute;
    };
    "/_authed/marketplace": {
      id: "/_authed/marketplace";
      path: "/marketplace";
      fullPath: "/marketplace";
      preLoaderRoute: typeof marketplaceIndexRouteImport;
      parentRoute: typeof consoleAuthedRoute;
    };
    "/_authed/mfa": {
      id: "/_authed/mfa";
      path: "/mfa";
      fullPath: "/mfa";
      preLoaderRoute: typeof MfaRouteImport;
      parentRoute: typeof consoleAuthedRoute;
    };
    "/_authed/moved": {
      id: "/_authed/moved";
      path: "/moved";
      fullPath: "/moved";
      preLoaderRoute: typeof MovedRouteImport;
      parentRoute: typeof consoleAuthedRoute;
    };
    "/_authed/onboarding": {
      id: "/_authed/onboarding";
      path: "/onboarding";
      fullPath: "/onboarding";
      preLoaderRoute: typeof OnboardingRouteImport;
      parentRoute: typeof consoleAuthedRoute;
    };
    "/_authed/reserved-compute": {
      id: "/_authed/reserved-compute";
      path: "/reserved-compute";
      fullPath: "/reserved-compute";
      preLoaderRoute: typeof marketplaceWorkspaceRouteImport;
      parentRoute: typeof consoleAuthedRoute;
    };
    "/auth/callback": {
      id: "/auth/callback";
      path: "/auth/callback";
      fullPath: "/auth/callback";
      preLoaderRoute: typeof AuthDotcallbackRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/_authed/$org/": {
      id: "/_authed/$org/";
      path: "/";
      fullPath: "/$org/";
      preLoaderRoute: typeof consoleOrgIndexRouteImport;
      parentRoute: typeof consoleOrgRoute;
    };
    "/_authed/$org/$project": {
      id: "/_authed/$org/$project";
      path: "/$project";
      fullPath: "/$org/$project";
      preLoaderRoute: typeof consoleProjectRouteImport;
      parentRoute: typeof consoleOrgRoute;
    };
    "/_authed/account/": {
      id: "/_authed/account/";
      path: "/";
      fullPath: "/account/";
      preLoaderRoute: typeof IndexRouteImport;
      parentRoute: typeof consoleAccountRoute;
    };
    "/_authed/account/privacy": {
      id: "/_authed/account/privacy";
      path: "/privacy";
      fullPath: "/account/privacy";
      preLoaderRoute: typeof PrivacyRouteImport;
      parentRoute: typeof consoleAccountRoute;
    };
    "/_authed/account/profile": {
      id: "/_authed/account/profile";
      path: "/profile";
      fullPath: "/account/profile";
      preLoaderRoute: typeof ProfileRouteImport;
      parentRoute: typeof consoleAccountRoute;
    };
    "/_authed/account/security": {
      id: "/_authed/account/security";
      path: "/security";
      fullPath: "/account/security";
      preLoaderRoute: typeof SecurityRouteImport;
      parentRoute: typeof consoleAccountRoute;
    };
    "/_authed/account/sshkeys": {
      id: "/_authed/account/sshkeys";
      path: "/sshkeys";
      fullPath: "/account/sshkeys";
      preLoaderRoute: typeof SshkeysRouteImport;
      parentRoute: typeof consoleAccountRoute;
    };
    "/_authed/cli-auth/": {
      id: "/_authed/cli-auth/";
      path: "/cli-auth";
      fullPath: "/cli-auth/";
      preLoaderRoute: typeof CliAuthDotindexRouteImport;
      parentRoute: typeof consoleAuthedRoute;
    };
    "/_authed/cli-auth/device": {
      id: "/_authed/cli-auth/device";
      path: "/cli-auth/device";
      fullPath: "/cli-auth/device";
      preLoaderRoute: typeof CliAuthDotdeviceRouteImport;
      parentRoute: typeof consoleAuthedRoute;
    };
    "/_authed/invite/$token": {
      id: "/_authed/invite/$token";
      path: "/invite/$token";
      fullPath: "/invite/$token";
      preLoaderRoute: typeof InviteDottokenRouteImport;
      parentRoute: typeof consoleAuthedRoute;
    };
    "/_authed/marketplace/$marketOrg": {
      id: "/_authed/marketplace/$marketOrg";
      path: "/marketplace/$marketOrg";
      fullPath: "/marketplace/$marketOrg";
      preLoaderRoute: typeof marketplaceOrgRouteImport;
      parentRoute: typeof consoleAuthedRoute;
    };
    "/_authed/oauth/consent": {
      id: "/_authed/oauth/consent";
      path: "/oauth/consent";
      fullPath: "/oauth/consent";
      preLoaderRoute: typeof OauthDotconsentRouteImport;
      parentRoute: typeof consoleAuthedRoute;
    };
    "/_authed/reserved-compute/$marketView": {
      id: "/_authed/reserved-compute/$marketView";
      path: "/$marketView";
      fullPath: "/reserved-compute/$marketView";
      preLoaderRoute: typeof marketplaceViewRouteImport;
      parentRoute: typeof marketplaceWorkspaceRoute;
    };
    "/_authed/$org/$project/": {
      id: "/_authed/$org/$project/";
      path: "/";
      fullPath: "/$org/$project/";
      preLoaderRoute: typeof consoleProjectIndexRouteImport;
      parentRoute: typeof consoleProjectRoute;
    };
    "/_authed/$org/$project/assets": {
      id: "/_authed/$org/$project/assets";
      path: "/assets";
      fullPath: "/$org/$project/assets";
      preLoaderRoute: typeof AssetsRouteImport;
      parentRoute: typeof consoleProjectRoute;
    };
    "/_authed/$org/$project/compute": {
      id: "/_authed/$org/$project/compute";
      path: "/compute";
      fullPath: "/$org/$project/compute";
      preLoaderRoute: typeof ComputeRouteImport;
      parentRoute: typeof consoleProjectRoute;
    };
    "/_authed/$org/$project/overview": {
      id: "/_authed/$org/$project/overview";
      path: "/overview";
      fullPath: "/$org/$project/overview";
      preLoaderRoute: typeof OverviewRouteImport;
      parentRoute: typeof consoleProjectRoute;
    };
    "/_authed/$org/$project/runs": {
      id: "/_authed/$org/$project/runs";
      path: "/runs";
      fullPath: "/$org/$project/runs";
      preLoaderRoute: typeof RunsRouteImport;
      parentRoute: typeof consoleProjectRoute;
    };
    "/_authed/$org/$project/ui-catalog": {
      id: "/_authed/$org/$project/ui-catalog";
      path: "/ui-catalog";
      fullPath: "/$org/$project/ui-catalog";
      preLoaderRoute: typeof UiCatalogRouteImport;
      parentRoute: typeof consoleProjectRoute;
    };
    "/_authed/$org/billing/": {
      id: "/_authed/$org/billing/";
      path: "/billing";
      fullPath: "/$org/billing/";
      preLoaderRoute: typeof BillingDotindexRouteImport;
      parentRoute: typeof consoleOrgRoute;
    };
    "/_authed/$org/billing/$tab": {
      id: "/_authed/$org/billing/$tab";
      path: "/billing/$tab";
      fullPath: "/$org/billing/$tab";
      preLoaderRoute: typeof BillingDottabRouteImport;
      parentRoute: typeof consoleOrgRoute;
    };
    "/_authed/$org/integrations/": {
      id: "/_authed/$org/integrations/";
      path: "/integrations";
      fullPath: "/$org/integrations/";
      preLoaderRoute: typeof IntegrationsIndexRouteImport;
      parentRoute: typeof consoleOrgRoute;
    };
    "/_authed/$org/integrations/mcp": {
      id: "/_authed/$org/integrations/mcp";
      path: "/integrations/mcp";
      fullPath: "/$org/integrations/mcp";
      preLoaderRoute: typeof IntegrationsMcpRouteImport;
      parentRoute: typeof consoleOrgRoute;
    };
    "/_authed/$org/settings/": {
      id: "/_authed/$org/settings/";
      path: "/settings";
      fullPath: "/$org/settings/";
      preLoaderRoute: typeof SettingsIndexRouteImport;
      parentRoute: typeof consoleOrgRoute;
    };
    "/_authed/$org/settings/apikeys": {
      id: "/_authed/$org/settings/apikeys";
      path: "/settings/apikeys";
      fullPath: "/$org/settings/apikeys";
      preLoaderRoute: typeof SettingsApikeysRouteImport;
      parentRoute: typeof consoleOrgRoute;
    };
    "/_authed/$org/settings/audit": {
      id: "/_authed/$org/settings/audit";
      path: "/settings/audit";
      fullPath: "/$org/settings/audit";
      preLoaderRoute: typeof SettingsAuditRouteImport;
      parentRoute: typeof consoleOrgRoute;
    };
    "/_authed/$org/settings/compute": {
      id: "/_authed/$org/settings/compute";
      path: "/settings/compute";
      fullPath: "/$org/settings/compute";
      preLoaderRoute: typeof SettingsComputeRouteImport;
      parentRoute: typeof consoleOrgRoute;
    };
    "/_authed/$org/settings/general": {
      id: "/_authed/$org/settings/general";
      path: "/settings/general";
      fullPath: "/$org/settings/general";
      preLoaderRoute: typeof SettingsGeneralRouteImport;
      parentRoute: typeof consoleOrgRoute;
    };
    "/_authed/$org/settings/invites": {
      id: "/_authed/$org/settings/invites";
      path: "/settings/invites";
      fullPath: "/$org/settings/invites";
      preLoaderRoute: typeof SettingsInvitesRouteImport;
      parentRoute: typeof consoleOrgRoute;
    };
    "/_authed/$org/settings/members": {
      id: "/_authed/$org/settings/members";
      path: "/settings/members";
      fullPath: "/$org/settings/members";
      preLoaderRoute: typeof SettingsMembersRouteImport;
      parentRoute: typeof consoleOrgRoute;
    };
    "/_authed/$org/settings/quotas": {
      id: "/_authed/$org/settings/quotas";
      path: "/settings/quotas";
      fullPath: "/$org/settings/quotas";
      preLoaderRoute: typeof SettingsQuotasRouteImport;
      parentRoute: typeof consoleOrgRoute;
    };
    "/_authed/$org/spot/": {
      id: "/_authed/$org/spot/";
      path: "/spot";
      fullPath: "/$org/spot/";
      preLoaderRoute: typeof SpotDotindexRouteImport;
      parentRoute: typeof consoleOrgRoute;
    };
    "/_authed/$org/spot/settings": {
      id: "/_authed/$org/spot/settings";
      path: "/spot/settings";
      fullPath: "/$org/spot/settings";
      preLoaderRoute: typeof SpotDotsettingsRouteImport;
      parentRoute: typeof consoleOrgRoute;
    };
    "/_authed/$org/spot/usage": {
      id: "/_authed/$org/spot/usage";
      path: "/spot/usage";
      fullPath: "/$org/spot/usage";
      preLoaderRoute: typeof SpotDotusageRouteImport;
      parentRoute: typeof consoleOrgRoute;
    };
    "/_authed/$org/team/": {
      id: "/_authed/$org/team/";
      path: "/team";
      fullPath: "/$org/team/";
      preLoaderRoute: typeof TeamIndexRouteImport;
      parentRoute: typeof consoleOrgRoute;
    };
    "/_authed/$org/team/domains": {
      id: "/_authed/$org/team/domains";
      path: "/team/domains";
      fullPath: "/$org/team/domains";
      preLoaderRoute: typeof TeamDomainsRouteImport;
      parentRoute: typeof consoleOrgRoute;
    };
    "/_authed/$org/team/invites": {
      id: "/_authed/$org/team/invites";
      path: "/team/invites";
      fullPath: "/$org/team/invites";
      preLoaderRoute: typeof TeamInvitesRouteImport;
      parentRoute: typeof consoleOrgRoute;
    };
    "/_authed/$org/team/members": {
      id: "/_authed/$org/team/members";
      path: "/team/members";
      fullPath: "/$org/team/members";
      preLoaderRoute: typeof TeamMembersRouteImport;
      parentRoute: typeof consoleOrgRoute;
    };
    "/_authed/$org/team/projects": {
      id: "/_authed/$org/team/projects";
      path: "/team/projects";
      fullPath: "/$org/team/projects";
      preLoaderRoute: typeof TeamProjectsRouteImport;
      parentRoute: typeof consoleOrgRoute;
    };
    "/_authed/$org/$project/agents/": {
      id: "/_authed/$org/$project/agents/";
      path: "/agents";
      fullPath: "/$org/$project/agents/";
      preLoaderRoute: typeof AgentsDotindexRouteImport;
      parentRoute: typeof consoleProjectRoute;
    };
    "/_authed/$org/$project/apps/$name": {
      id: "/_authed/$org/$project/apps/$name";
      path: "/apps/$name";
      fullPath: "/$org/$project/apps/$name";
      preLoaderRoute: typeof AppsDotnameRouteImport;
      parentRoute: typeof consoleProjectRoute;
    };
    "/_authed/$org/$project/connections/": {
      id: "/_authed/$org/$project/connections/";
      path: "/connections";
      fullPath: "/$org/$project/connections/";
      preLoaderRoute: typeof ConnectionsIndexRouteImport;
      parentRoute: typeof consoleProjectRoute;
    };
    "/_authed/$org/$project/connections/$name": {
      id: "/_authed/$org/$project/connections/$name";
      path: "/connections/$name";
      fullPath: "/$org/$project/connections/$name";
      preLoaderRoute: typeof ConnectionsNameRouteImport;
      parentRoute: typeof consoleProjectRoute;
    };
    "/_authed/$org/$project/connections/new": {
      id: "/_authed/$org/$project/connections/new";
      path: "/connections/new";
      fullPath: "/$org/$project/connections/new";
      preLoaderRoute: typeof ConnectionsNewRouteImport;
      parentRoute: typeof consoleProjectRoute;
    };
    "/_authed/$org/$project/environments/": {
      id: "/_authed/$org/$project/environments/";
      path: "/environments";
      fullPath: "/$org/$project/environments/";
      preLoaderRoute: typeof EnvironmentsDotindexRouteImport;
      parentRoute: typeof consoleProjectRoute;
    };
    "/_authed/$org/$project/environments/$name": {
      id: "/_authed/$org/$project/environments/$name";
      path: "/environments/$name";
      fullPath: "/$org/$project/environments/$name";
      preLoaderRoute: typeof EnvironmentsDotnameRouteImport;
      parentRoute: typeof consoleProjectRoute;
    };
    "/_authed/$org/$project/functions/": {
      id: "/_authed/$org/$project/functions/";
      path: "/functions";
      fullPath: "/$org/$project/functions/";
      preLoaderRoute: typeof FunctionsDotindexRouteImport;
      parentRoute: typeof consoleProjectRoute;
    };
    "/_authed/$org/$project/images/": {
      id: "/_authed/$org/$project/images/";
      path: "/images";
      fullPath: "/$org/$project/images/";
      preLoaderRoute: typeof ImagesDotindexRouteImport;
      parentRoute: typeof consoleProjectRoute;
    };
    "/_authed/$org/$project/inference/": {
      id: "/_authed/$org/$project/inference/";
      path: "/inference";
      fullPath: "/$org/$project/inference/";
      preLoaderRoute: typeof InferenceDotindexRouteImport;
      parentRoute: typeof consoleProjectRoute;
    };
    "/_authed/$org/$project/inferenceendpoints/new": {
      id: "/_authed/$org/$project/inferenceendpoints/new";
      path: "/inferenceendpoints/new";
      fullPath: "/$org/$project/inferenceendpoints/new";
      preLoaderRoute: typeof InferenceendpointsDotnewRouteImport;
      parentRoute: typeof consoleProjectRoute;
    };
    "/_authed/$org/$project/instances/": {
      id: "/_authed/$org/$project/instances/";
      path: "/instances";
      fullPath: "/$org/$project/instances/";
      preLoaderRoute: typeof InstancesDotindexRouteImport;
      parentRoute: typeof consoleProjectRoute;
    };
    "/_authed/$org/$project/instances/new": {
      id: "/_authed/$org/$project/instances/new";
      path: "/instances/new";
      fullPath: "/$org/$project/instances/new";
      preLoaderRoute: typeof InstancesDotnewRouteImport;
      parentRoute: typeof consoleProjectRoute;
    };
    "/_authed/$org/$project/jobs/new": {
      id: "/_authed/$org/$project/jobs/new";
      path: "/jobs/new";
      fullPath: "/$org/$project/jobs/new";
      preLoaderRoute: typeof JobsDotnewRouteImport;
      parentRoute: typeof consoleProjectRoute;
    };
    "/_authed/$org/$project/pools/": {
      id: "/_authed/$org/$project/pools/";
      path: "/pools";
      fullPath: "/$org/$project/pools/";
      preLoaderRoute: typeof PoolsIndexRouteImport;
      parentRoute: typeof consoleProjectRoute;
    };
    "/_authed/$org/$project/pools/new": {
      id: "/_authed/$org/$project/pools/new";
      path: "/pools/new";
      fullPath: "/$org/$project/pools/new";
      preLoaderRoute: typeof PoolsNewRouteImport;
      parentRoute: typeof consoleProjectRoute;
    };
    "/_authed/$org/$project/reservedhosts/": {
      id: "/_authed/$org/$project/reservedhosts/";
      path: "/reservedhosts";
      fullPath: "/$org/$project/reservedhosts/";
      preLoaderRoute: typeof ReservedhostsDotindexRouteImport;
      parentRoute: typeof consoleProjectRoute;
    };
    "/_authed/$org/$project/reservedhosts/requests": {
      id: "/_authed/$org/$project/reservedhosts/requests";
      path: "/reservedhosts/requests";
      fullPath: "/$org/$project/reservedhosts/requests";
      preLoaderRoute: typeof ReservedhostsDotrequestsRouteImport;
      parentRoute: typeof consoleProjectRoute;
    };
    "/_authed/$org/$project/sandboxes/": {
      id: "/_authed/$org/$project/sandboxes/";
      path: "/sandboxes";
      fullPath: "/$org/$project/sandboxes/";
      preLoaderRoute: typeof SandboxesDotindexRouteImport;
      parentRoute: typeof consoleProjectRoute;
    };
    "/_authed/$org/$project/sandboxes/new": {
      id: "/_authed/$org/$project/sandboxes/new";
      path: "/sandboxes/new";
      fullPath: "/$org/$project/sandboxes/new";
      preLoaderRoute: typeof SandboxesDotnewRouteImport;
      parentRoute: typeof consoleProjectRoute;
    };
    "/_authed/$org/$project/secrets/": {
      id: "/_authed/$org/$project/secrets/";
      path: "/secrets";
      fullPath: "/$org/$project/secrets/";
      preLoaderRoute: typeof SecretsDotindexRouteImport;
      parentRoute: typeof consoleProjectRoute;
    };
    "/_authed/$org/$project/secrets/$name": {
      id: "/_authed/$org/$project/secrets/$name";
      path: "/secrets/$name";
      fullPath: "/$org/$project/secrets/$name";
      preLoaderRoute: typeof SecretsDotnameRouteImport;
      parentRoute: typeof consoleProjectRoute;
    };
    "/_authed/$org/$project/serviceaccounts/": {
      id: "/_authed/$org/$project/serviceaccounts/";
      path: "/serviceaccounts";
      fullPath: "/$org/$project/serviceaccounts/";
      preLoaderRoute: typeof ServiceaccountsIndexRouteImport;
      parentRoute: typeof consoleProjectRoute;
    };
    "/_authed/$org/$project/serviceaccounts/$name": {
      id: "/_authed/$org/$project/serviceaccounts/$name";
      path: "/serviceaccounts/$name";
      fullPath: "/$org/$project/serviceaccounts/$name";
      preLoaderRoute: typeof ServiceaccountsNameRouteImport;
      parentRoute: typeof consoleProjectRoute;
    };
    "/_authed/$org/$project/trainingjobs/": {
      id: "/_authed/$org/$project/trainingjobs/";
      path: "/trainingjobs";
      fullPath: "/$org/$project/trainingjobs/";
      preLoaderRoute: typeof TrainingjobsDotindexRouteImport;
      parentRoute: typeof consoleProjectRoute;
    };
    "/_authed/$org/$project/trainingruntimes/$name": {
      id: "/_authed/$org/$project/trainingruntimes/$name";
      path: "/trainingruntimes/$name";
      fullPath: "/$org/$project/trainingruntimes/$name";
      preLoaderRoute: typeof TrainingruntimesDotnameRouteImport;
      parentRoute: typeof consoleProjectRoute;
    };
    "/_authed/$org/$project/volumes/": {
      id: "/_authed/$org/$project/volumes/";
      path: "/volumes";
      fullPath: "/$org/$project/volumes/";
      preLoaderRoute: typeof VolumesDotindexRouteImport;
      parentRoute: typeof consoleProjectRoute;
    };
    "/_authed/$org/$project/workspaces/": {
      id: "/_authed/$org/$project/workspaces/";
      path: "/workspaces";
      fullPath: "/$org/$project/workspaces/";
      preLoaderRoute: typeof WorkspacesDotindexRouteImport;
      parentRoute: typeof consoleProjectRoute;
    };
    "/_authed/$org/$project/workspaces/new": {
      id: "/_authed/$org/$project/workspaces/new";
      path: "/workspaces/new";
      fullPath: "/$org/$project/workspaces/new";
      preLoaderRoute: typeof WorkspacesDotnewRouteImport;
      parentRoute: typeof consoleProjectRoute;
    };
    "/_authed/$org/billing/budgets/$name": {
      id: "/_authed/$org/billing/budgets/$name";
      path: "/billing/budgets/$name";
      fullPath: "/$org/billing/budgets/$name";
      preLoaderRoute: typeof BillingDotbudgetsDotnameRouteImport;
      parentRoute: typeof consoleOrgRoute;
    };
    "/_authed/$org/infrastructure/cloudaccounts/": {
      id: "/_authed/$org/infrastructure/cloudaccounts/";
      path: "/infrastructure/cloudaccounts";
      fullPath: "/$org/infrastructure/cloudaccounts/";
      preLoaderRoute: typeof InfrastructureCloudaccountsDotindexRouteImport;
      parentRoute: typeof consoleOrgRoute;
    };
    "/_authed/$org/infrastructure/cloudaccounts/$name": {
      id: "/_authed/$org/infrastructure/cloudaccounts/$name";
      path: "/infrastructure/cloudaccounts/$name";
      fullPath: "/$org/infrastructure/cloudaccounts/$name";
      preLoaderRoute: typeof InfrastructureCloudaccountsDotnameRouteImport;
      parentRoute: typeof consoleOrgRoute;
    };
    "/_authed/$org/infrastructure/nodes/": {
      id: "/_authed/$org/infrastructure/nodes/";
      path: "/infrastructure/nodes";
      fullPath: "/$org/infrastructure/nodes/";
      preLoaderRoute: typeof InfrastructureNodesDotindexRouteImport;
      parentRoute: typeof consoleOrgRoute;
    };
    "/_authed/$org/infrastructure/nodes/$name": {
      id: "/_authed/$org/infrastructure/nodes/$name";
      path: "/infrastructure/nodes/$name";
      fullPath: "/$org/infrastructure/nodes/$name";
      preLoaderRoute: typeof InfrastructureNodesDotnameRouteImport;
      parentRoute: typeof consoleOrgRoute;
    };
    "/_authed/$org/settings/webhooks/": {
      id: "/_authed/$org/settings/webhooks/";
      path: "/settings/webhooks";
      fullPath: "/$org/settings/webhooks/";
      preLoaderRoute: typeof SettingsWebhooksDotindexRouteImport;
      parentRoute: typeof consoleOrgRoute;
    };
    "/_authed/$org/settings/webhooks/$name": {
      id: "/_authed/$org/settings/webhooks/$name";
      path: "/settings/webhooks/$name";
      fullPath: "/$org/settings/webhooks/$name";
      preLoaderRoute: typeof SettingsWebhooksDotnameRouteImport;
      parentRoute: typeof consoleOrgRoute;
    };
    "/_authed/$org/$project/agentgroups/$name/$tab": {
      id: "/_authed/$org/$project/agentgroups/$name/$tab";
      path: "/agentgroups/$name/$tab";
      fullPath: "/$org/$project/agentgroups/$name/$tab";
      preLoaderRoute: typeof AgentgroupsDotnameDottabRouteImport;
      parentRoute: typeof consoleProjectRoute;
    };
    "/_authed/$org/$project/agentruns/$name/$tab": {
      id: "/_authed/$org/$project/agentruns/$name/$tab";
      path: "/agentruns/$name/$tab";
      fullPath: "/$org/$project/agentruns/$name/$tab";
      preLoaderRoute: typeof AgentrunsDotnameDottabRouteImport;
      parentRoute: typeof consoleProjectRoute;
    };
    "/_authed/$org/$project/agents/$name/$tab": {
      id: "/_authed/$org/$project/agents/$name/$tab";
      path: "/agents/$name/$tab";
      fullPath: "/$org/$project/agents/$name/$tab";
      preLoaderRoute: typeof AgentsDotnameDottabRouteImport;
      parentRoute: typeof consoleProjectRoute;
    };
    "/_authed/$org/$project/functions/$name/$tab": {
      id: "/_authed/$org/$project/functions/$name/$tab";
      path: "/functions/$name/$tab";
      fullPath: "/$org/$project/functions/$name/$tab";
      preLoaderRoute: typeof FunctionsDotnameDottabRouteImport;
      parentRoute: typeof consoleProjectRoute;
    };
    "/_authed/$org/$project/images/$name/": {
      id: "/_authed/$org/$project/images/$name/";
      path: "/images/$name";
      fullPath: "/$org/$project/images/$name/";
      preLoaderRoute: typeof ImagesDotnameDotindexRouteImport;
      parentRoute: typeof consoleProjectRoute;
    };
    "/_authed/$org/$project/images/$name/$tab": {
      id: "/_authed/$org/$project/images/$name/$tab";
      path: "/images/$name/$tab";
      fullPath: "/$org/$project/images/$name/$tab";
      preLoaderRoute: typeof ImagesDotnameDottabRouteImport;
      parentRoute: typeof consoleProjectRoute;
    };
    "/_authed/$org/$project/inferenceendpoints/$name/": {
      id: "/_authed/$org/$project/inferenceendpoints/$name/";
      path: "/inferenceendpoints/$name";
      fullPath: "/$org/$project/inferenceendpoints/$name/";
      preLoaderRoute: typeof InferenceendpointsDotnameDotindexRouteImport;
      parentRoute: typeof consoleProjectRoute;
    };
    "/_authed/$org/$project/inferenceendpoints/$name/$tab": {
      id: "/_authed/$org/$project/inferenceendpoints/$name/$tab";
      path: "/inferenceendpoints/$name/$tab";
      fullPath: "/$org/$project/inferenceendpoints/$name/$tab";
      preLoaderRoute: typeof InferenceendpointsDotnameDottabRouteImport;
      parentRoute: typeof consoleProjectRoute;
    };
    "/_authed/$org/$project/instances/$name/$tab": {
      id: "/_authed/$org/$project/instances/$name/$tab";
      path: "/instances/$name/$tab";
      fullPath: "/$org/$project/instances/$name/$tab";
      preLoaderRoute: typeof InstancesDotnameDottabRouteImport;
      parentRoute: typeof consoleProjectRoute;
    };
    "/_authed/$org/$project/jobs/$name/$tab": {
      id: "/_authed/$org/$project/jobs/$name/$tab";
      path: "/jobs/$name/$tab";
      fullPath: "/$org/$project/jobs/$name/$tab";
      preLoaderRoute: typeof JobsDotnameDottabRouteImport;
      parentRoute: typeof consoleProjectRoute;
    };
    "/_authed/$org/$project/pipelines/$name/$tab": {
      id: "/_authed/$org/$project/pipelines/$name/$tab";
      path: "/pipelines/$name/$tab";
      fullPath: "/$org/$project/pipelines/$name/$tab";
      preLoaderRoute: typeof PipelinesDotnameDottabRouteImport;
      parentRoute: typeof consoleProjectRoute;
    };
    "/_authed/$org/$project/pools/$name/": {
      id: "/_authed/$org/$project/pools/$name/";
      path: "/pools/$name";
      fullPath: "/$org/$project/pools/$name/";
      preLoaderRoute: typeof PoolsNameDotindexRouteImport;
      parentRoute: typeof consoleProjectRoute;
    };
    "/_authed/$org/$project/pools/$name/$tab": {
      id: "/_authed/$org/$project/pools/$name/$tab";
      path: "/pools/$name/$tab";
      fullPath: "/$org/$project/pools/$name/$tab";
      preLoaderRoute: typeof PoolsNameDottabRouteImport;
      parentRoute: typeof consoleProjectRoute;
    };
    "/_authed/$org/$project/reservedhosts/$name/$tab": {
      id: "/_authed/$org/$project/reservedhosts/$name/$tab";
      path: "/reservedhosts/$name/$tab";
      fullPath: "/$org/$project/reservedhosts/$name/$tab";
      preLoaderRoute: typeof ReservedhostsDotnameDottabRouteImport;
      parentRoute: typeof consoleProjectRoute;
    };
    "/_authed/$org/$project/sandboxes/$name/$tab": {
      id: "/_authed/$org/$project/sandboxes/$name/$tab";
      path: "/sandboxes/$name/$tab";
      fullPath: "/$org/$project/sandboxes/$name/$tab";
      preLoaderRoute: typeof SandboxesDotnameDottabRouteImport;
      parentRoute: typeof consoleProjectRoute;
    };
    "/_authed/$org/$project/sweeps/$name/$tab": {
      id: "/_authed/$org/$project/sweeps/$name/$tab";
      path: "/sweeps/$name/$tab";
      fullPath: "/$org/$project/sweeps/$name/$tab";
      preLoaderRoute: typeof SweepsDotnameDottabRouteImport;
      parentRoute: typeof consoleProjectRoute;
    };
    "/_authed/$org/$project/trainingjobs/$name/$tab": {
      id: "/_authed/$org/$project/trainingjobs/$name/$tab";
      path: "/trainingjobs/$name/$tab";
      fullPath: "/$org/$project/trainingjobs/$name/$tab";
      preLoaderRoute: typeof TrainingjobsDotnameDottabRouteImport;
      parentRoute: typeof consoleProjectRoute;
    };
    "/_authed/$org/$project/volumes/$name/": {
      id: "/_authed/$org/$project/volumes/$name/";
      path: "/volumes/$name";
      fullPath: "/$org/$project/volumes/$name/";
      preLoaderRoute: typeof VolumesDotnameDotindexRouteImport;
      parentRoute: typeof consoleProjectRoute;
    };
    "/_authed/$org/$project/volumes/$name/$tab": {
      id: "/_authed/$org/$project/volumes/$name/$tab";
      path: "/volumes/$name/$tab";
      fullPath: "/$org/$project/volumes/$name/$tab";
      preLoaderRoute: typeof VolumesDotnameDottabRouteImport;
      parentRoute: typeof consoleProjectRoute;
    };
    "/_authed/$org/$project/workspaces/$name/$tab": {
      id: "/_authed/$org/$project/workspaces/$name/$tab";
      path: "/workspaces/$name/$tab";
      fullPath: "/$org/$project/workspaces/$name/$tab";
      preLoaderRoute: typeof WorkspacesDotnameDottabRouteImport;
      parentRoute: typeof consoleProjectRoute;
    };
    "/_authed/$org/infrastructure/cloudaccounts/new/aws": {
      id: "/_authed/$org/infrastructure/cloudaccounts/new/aws";
      path: "/infrastructure/cloudaccounts/new/aws";
      fullPath: "/$org/infrastructure/cloudaccounts/new/aws";
      preLoaderRoute: typeof InfrastructureCloudaccountsDotnewDotawsRouteImport;
      parentRoute: typeof consoleOrgRoute;
    };
    "/_authed/$org/infrastructure/cloudaccounts/new/azure": {
      id: "/_authed/$org/infrastructure/cloudaccounts/new/azure";
      path: "/infrastructure/cloudaccounts/new/azure";
      fullPath: "/$org/infrastructure/cloudaccounts/new/azure";
      preLoaderRoute: typeof InfrastructureCloudaccountsDotnewDotazureRouteImport;
      parentRoute: typeof consoleOrgRoute;
    };
    "/_authed/$org/infrastructure/cloudaccounts/new/gcp": {
      id: "/_authed/$org/infrastructure/cloudaccounts/new/gcp";
      path: "/infrastructure/cloudaccounts/new/gcp";
      fullPath: "/$org/infrastructure/cloudaccounts/new/gcp";
      preLoaderRoute: typeof InfrastructureCloudaccountsDotnewDotgcpRouteImport;
      parentRoute: typeof consoleOrgRoute;
    };
    "/_authed/$org/infrastructure/cloudaccounts/new/key": {
      id: "/_authed/$org/infrastructure/cloudaccounts/new/key";
      path: "/infrastructure/cloudaccounts/new/key";
      fullPath: "/$org/infrastructure/cloudaccounts/new/key";
      preLoaderRoute: typeof InfrastructureCloudaccountsDotnewDotkeyRouteImport;
      parentRoute: typeof consoleOrgRoute;
    };
    "/_authed/$org/infrastructure/cloudaccounts/new/kubernetes": {
      id: "/_authed/$org/infrastructure/cloudaccounts/new/kubernetes";
      path: "/infrastructure/cloudaccounts/new/kubernetes";
      fullPath: "/$org/infrastructure/cloudaccounts/new/kubernetes";
      preLoaderRoute: typeof InfrastructureCloudaccountsDotnewDotkubernetesRouteImport;
      parentRoute: typeof consoleOrgRoute;
    };
    "/_authed/$org/infrastructure/cloudaccounts/new/azure_/callback": {
      id: "/_authed/$org/infrastructure/cloudaccounts/new/azure_/callback";
      path: "/infrastructure/cloudaccounts/new/azure/callback";
      fullPath: "/$org/infrastructure/cloudaccounts/new/azure/callback";
      preLoaderRoute: typeof InfrastructureCloudaccountsDotnewDotazure_DotcallbackRouteImport;
      parentRoute: typeof consoleOrgRoute;
    };
    "/_authed/$org/infrastructure/cloudaccounts/new/gcp_/callback": {
      id: "/_authed/$org/infrastructure/cloudaccounts/new/gcp_/callback";
      path: "/infrastructure/cloudaccounts/new/gcp/callback";
      fullPath: "/$org/infrastructure/cloudaccounts/new/gcp/callback";
      preLoaderRoute: typeof InfrastructureCloudaccountsDotnewDotgcp_DotcallbackRouteImport;
      parentRoute: typeof consoleOrgRoute;
    };
  }
}

interface consoleProjectRouteChildren {
  consoleProjectIndexRoute: typeof consoleProjectIndexRoute;
  AssetsRoute: typeof AssetsRoute;
  ComputeRoute: typeof ComputeRoute;
  OverviewRoute: typeof OverviewRoute;
  RunsRoute: typeof RunsRoute;
  UiCatalogRoute: typeof UiCatalogRoute;
  AppsDotnameRoute: typeof AppsDotnameRoute;
  ConnectionsNameRoute: typeof ConnectionsNameRoute;
  ConnectionsNewRoute: typeof ConnectionsNewRoute;
  EnvironmentsDotnameRoute: typeof EnvironmentsDotnameRoute;
  InferenceendpointsDotnewRoute: typeof InferenceendpointsDotnewRoute;
  InstancesDotnewRoute: typeof InstancesDotnewRoute;
  JobsDotnewRoute: typeof JobsDotnewRoute;
  PoolsNewRoute: typeof PoolsNewRoute;
  ReservedhostsDotrequestsRoute: typeof ReservedhostsDotrequestsRoute;
  SandboxesDotnewRoute: typeof SandboxesDotnewRoute;
  SecretsDotnameRoute: typeof SecretsDotnameRoute;
  ServiceaccountsNameRoute: typeof ServiceaccountsNameRoute;
  TrainingruntimesDotnameRoute: typeof TrainingruntimesDotnameRoute;
  WorkspacesDotnewRoute: typeof WorkspacesDotnewRoute;
  AgentsDotindexRoute: typeof AgentsDotindexRoute;
  ConnectionsIndexRoute: typeof ConnectionsIndexRoute;
  EnvironmentsDotindexRoute: typeof EnvironmentsDotindexRoute;
  FunctionsDotindexRoute: typeof FunctionsDotindexRoute;
  ImagesDotindexRoute: typeof ImagesDotindexRoute;
  InferenceDotindexRoute: typeof InferenceDotindexRoute;
  InstancesDotindexRoute: typeof InstancesDotindexRoute;
  PoolsIndexRoute: typeof PoolsIndexRoute;
  ReservedhostsDotindexRoute: typeof ReservedhostsDotindexRoute;
  SandboxesDotindexRoute: typeof SandboxesDotindexRoute;
  SecretsDotindexRoute: typeof SecretsDotindexRoute;
  ServiceaccountsIndexRoute: typeof ServiceaccountsIndexRoute;
  TrainingjobsDotindexRoute: typeof TrainingjobsDotindexRoute;
  VolumesDotindexRoute: typeof VolumesDotindexRoute;
  WorkspacesDotindexRoute: typeof WorkspacesDotindexRoute;
  AgentgroupsDotnameDottabRoute: typeof AgentgroupsDotnameDottabRoute;
  AgentrunsDotnameDottabRoute: typeof AgentrunsDotnameDottabRoute;
  AgentsDotnameDottabRoute: typeof AgentsDotnameDottabRoute;
  FunctionsDotnameDottabRoute: typeof FunctionsDotnameDottabRoute;
  ImagesDotnameDottabRoute: typeof ImagesDotnameDottabRoute;
  InferenceendpointsDotnameDottabRoute: typeof InferenceendpointsDotnameDottabRoute;
  InstancesDotnameDottabRoute: typeof InstancesDotnameDottabRoute;
  JobsDotnameDottabRoute: typeof JobsDotnameDottabRoute;
  PipelinesDotnameDottabRoute: typeof PipelinesDotnameDottabRoute;
  PoolsNameDottabRoute: typeof PoolsNameDottabRoute;
  ReservedhostsDotnameDottabRoute: typeof ReservedhostsDotnameDottabRoute;
  SandboxesDotnameDottabRoute: typeof SandboxesDotnameDottabRoute;
  SweepsDotnameDottabRoute: typeof SweepsDotnameDottabRoute;
  TrainingjobsDotnameDottabRoute: typeof TrainingjobsDotnameDottabRoute;
  VolumesDotnameDottabRoute: typeof VolumesDotnameDottabRoute;
  WorkspacesDotnameDottabRoute: typeof WorkspacesDotnameDottabRoute;
  ImagesDotnameDotindexRoute: typeof ImagesDotnameDotindexRoute;
  InferenceendpointsDotnameDotindexRoute: typeof InferenceendpointsDotnameDotindexRoute;
  PoolsNameDotindexRoute: typeof PoolsNameDotindexRoute;
  VolumesDotnameDotindexRoute: typeof VolumesDotnameDotindexRoute;
}

const consoleProjectRouteChildren: consoleProjectRouteChildren = {
  consoleProjectIndexRoute: consoleProjectIndexRoute,
  AssetsRoute: AssetsRoute,
  ComputeRoute: ComputeRoute,
  OverviewRoute: OverviewRoute,
  RunsRoute: RunsRoute,
  UiCatalogRoute: UiCatalogRoute,
  AppsDotnameRoute: AppsDotnameRoute,
  ConnectionsNameRoute: ConnectionsNameRoute,
  ConnectionsNewRoute: ConnectionsNewRoute,
  EnvironmentsDotnameRoute: EnvironmentsDotnameRoute,
  InferenceendpointsDotnewRoute: InferenceendpointsDotnewRoute,
  InstancesDotnewRoute: InstancesDotnewRoute,
  JobsDotnewRoute: JobsDotnewRoute,
  PoolsNewRoute: PoolsNewRoute,
  ReservedhostsDotrequestsRoute: ReservedhostsDotrequestsRoute,
  SandboxesDotnewRoute: SandboxesDotnewRoute,
  SecretsDotnameRoute: SecretsDotnameRoute,
  ServiceaccountsNameRoute: ServiceaccountsNameRoute,
  TrainingruntimesDotnameRoute: TrainingruntimesDotnameRoute,
  WorkspacesDotnewRoute: WorkspacesDotnewRoute,
  AgentsDotindexRoute: AgentsDotindexRoute,
  ConnectionsIndexRoute: ConnectionsIndexRoute,
  EnvironmentsDotindexRoute: EnvironmentsDotindexRoute,
  FunctionsDotindexRoute: FunctionsDotindexRoute,
  ImagesDotindexRoute: ImagesDotindexRoute,
  InferenceDotindexRoute: InferenceDotindexRoute,
  InstancesDotindexRoute: InstancesDotindexRoute,
  PoolsIndexRoute: PoolsIndexRoute,
  ReservedhostsDotindexRoute: ReservedhostsDotindexRoute,
  SandboxesDotindexRoute: SandboxesDotindexRoute,
  SecretsDotindexRoute: SecretsDotindexRoute,
  ServiceaccountsIndexRoute: ServiceaccountsIndexRoute,
  TrainingjobsDotindexRoute: TrainingjobsDotindexRoute,
  VolumesDotindexRoute: VolumesDotindexRoute,
  WorkspacesDotindexRoute: WorkspacesDotindexRoute,
  AgentgroupsDotnameDottabRoute: AgentgroupsDotnameDottabRoute,
  AgentrunsDotnameDottabRoute: AgentrunsDotnameDottabRoute,
  AgentsDotnameDottabRoute: AgentsDotnameDottabRoute,
  FunctionsDotnameDottabRoute: FunctionsDotnameDottabRoute,
  ImagesDotnameDottabRoute: ImagesDotnameDottabRoute,
  InferenceendpointsDotnameDottabRoute: InferenceendpointsDotnameDottabRoute,
  InstancesDotnameDottabRoute: InstancesDotnameDottabRoute,
  JobsDotnameDottabRoute: JobsDotnameDottabRoute,
  PipelinesDotnameDottabRoute: PipelinesDotnameDottabRoute,
  PoolsNameDottabRoute: PoolsNameDottabRoute,
  ReservedhostsDotnameDottabRoute: ReservedhostsDotnameDottabRoute,
  SandboxesDotnameDottabRoute: SandboxesDotnameDottabRoute,
  SweepsDotnameDottabRoute: SweepsDotnameDottabRoute,
  TrainingjobsDotnameDottabRoute: TrainingjobsDotnameDottabRoute,
  VolumesDotnameDottabRoute: VolumesDotnameDottabRoute,
  WorkspacesDotnameDottabRoute: WorkspacesDotnameDottabRoute,
  ImagesDotnameDotindexRoute: ImagesDotnameDotindexRoute,
  InferenceendpointsDotnameDotindexRoute:
    InferenceendpointsDotnameDotindexRoute,
  PoolsNameDotindexRoute: PoolsNameDotindexRoute,
  VolumesDotnameDotindexRoute: VolumesDotnameDotindexRoute,
};

const consoleProjectRouteWithChildren = consoleProjectRoute._addFileChildren(
  consoleProjectRouteChildren,
);

interface consoleOrgRouteChildren {
  consoleOrgIndexRoute: typeof consoleOrgIndexRoute;
  consoleProjectRoute: typeof consoleProjectRouteWithChildren;
  BillingDottabRoute: typeof BillingDottabRoute;
  IntegrationsMcpRoute: typeof IntegrationsMcpRoute;
  SettingsApikeysRoute: typeof SettingsApikeysRoute;
  SettingsAuditRoute: typeof SettingsAuditRoute;
  SettingsComputeRoute: typeof SettingsComputeRoute;
  SettingsGeneralRoute: typeof SettingsGeneralRoute;
  SettingsInvitesRoute: typeof SettingsInvitesRoute;
  SettingsMembersRoute: typeof SettingsMembersRoute;
  SettingsQuotasRoute: typeof SettingsQuotasRoute;
  SpotDotsettingsRoute: typeof SpotDotsettingsRoute;
  SpotDotusageRoute: typeof SpotDotusageRoute;
  TeamDomainsRoute: typeof TeamDomainsRoute;
  TeamInvitesRoute: typeof TeamInvitesRoute;
  TeamMembersRoute: typeof TeamMembersRoute;
  TeamProjectsRoute: typeof TeamProjectsRoute;
  BillingDotindexRoute: typeof BillingDotindexRoute;
  IntegrationsIndexRoute: typeof IntegrationsIndexRoute;
  SettingsIndexRoute: typeof SettingsIndexRoute;
  SpotDotindexRoute: typeof SpotDotindexRoute;
  TeamIndexRoute: typeof TeamIndexRoute;
  BillingDotbudgetsDotnameRoute: typeof BillingDotbudgetsDotnameRoute;
  InfrastructureCloudaccountsDotnameRoute: typeof InfrastructureCloudaccountsDotnameRoute;
  InfrastructureNodesDotnameRoute: typeof InfrastructureNodesDotnameRoute;
  SettingsWebhooksDotnameRoute: typeof SettingsWebhooksDotnameRoute;
  InfrastructureCloudaccountsDotindexRoute: typeof InfrastructureCloudaccountsDotindexRoute;
  InfrastructureNodesDotindexRoute: typeof InfrastructureNodesDotindexRoute;
  SettingsWebhooksDotindexRoute: typeof SettingsWebhooksDotindexRoute;
  InfrastructureCloudaccountsDotnewDotawsRoute: typeof InfrastructureCloudaccountsDotnewDotawsRoute;
  InfrastructureCloudaccountsDotnewDotazureRoute: typeof InfrastructureCloudaccountsDotnewDotazureRoute;
  InfrastructureCloudaccountsDotnewDotgcpRoute: typeof InfrastructureCloudaccountsDotnewDotgcpRoute;
  InfrastructureCloudaccountsDotnewDotkeyRoute: typeof InfrastructureCloudaccountsDotnewDotkeyRoute;
  InfrastructureCloudaccountsDotnewDotkubernetesRoute: typeof InfrastructureCloudaccountsDotnewDotkubernetesRoute;
  InfrastructureCloudaccountsDotnewDotazure_DotcallbackRoute: typeof InfrastructureCloudaccountsDotnewDotazure_DotcallbackRoute;
  InfrastructureCloudaccountsDotnewDotgcp_DotcallbackRoute: typeof InfrastructureCloudaccountsDotnewDotgcp_DotcallbackRoute;
}

const consoleOrgRouteChildren: consoleOrgRouteChildren = {
  consoleOrgIndexRoute: consoleOrgIndexRoute,
  consoleProjectRoute: consoleProjectRouteWithChildren,
  BillingDottabRoute: BillingDottabRoute,
  IntegrationsMcpRoute: IntegrationsMcpRoute,
  SettingsApikeysRoute: SettingsApikeysRoute,
  SettingsAuditRoute: SettingsAuditRoute,
  SettingsComputeRoute: SettingsComputeRoute,
  SettingsGeneralRoute: SettingsGeneralRoute,
  SettingsInvitesRoute: SettingsInvitesRoute,
  SettingsMembersRoute: SettingsMembersRoute,
  SettingsQuotasRoute: SettingsQuotasRoute,
  SpotDotsettingsRoute: SpotDotsettingsRoute,
  SpotDotusageRoute: SpotDotusageRoute,
  TeamDomainsRoute: TeamDomainsRoute,
  TeamInvitesRoute: TeamInvitesRoute,
  TeamMembersRoute: TeamMembersRoute,
  TeamProjectsRoute: TeamProjectsRoute,
  BillingDotindexRoute: BillingDotindexRoute,
  IntegrationsIndexRoute: IntegrationsIndexRoute,
  SettingsIndexRoute: SettingsIndexRoute,
  SpotDotindexRoute: SpotDotindexRoute,
  TeamIndexRoute: TeamIndexRoute,
  BillingDotbudgetsDotnameRoute: BillingDotbudgetsDotnameRoute,
  InfrastructureCloudaccountsDotnameRoute:
    InfrastructureCloudaccountsDotnameRoute,
  InfrastructureNodesDotnameRoute: InfrastructureNodesDotnameRoute,
  SettingsWebhooksDotnameRoute: SettingsWebhooksDotnameRoute,
  InfrastructureCloudaccountsDotindexRoute:
    InfrastructureCloudaccountsDotindexRoute,
  InfrastructureNodesDotindexRoute: InfrastructureNodesDotindexRoute,
  SettingsWebhooksDotindexRoute: SettingsWebhooksDotindexRoute,
  InfrastructureCloudaccountsDotnewDotawsRoute:
    InfrastructureCloudaccountsDotnewDotawsRoute,
  InfrastructureCloudaccountsDotnewDotazureRoute:
    InfrastructureCloudaccountsDotnewDotazureRoute,
  InfrastructureCloudaccountsDotnewDotgcpRoute:
    InfrastructureCloudaccountsDotnewDotgcpRoute,
  InfrastructureCloudaccountsDotnewDotkeyRoute:
    InfrastructureCloudaccountsDotnewDotkeyRoute,
  InfrastructureCloudaccountsDotnewDotkubernetesRoute:
    InfrastructureCloudaccountsDotnewDotkubernetesRoute,
  InfrastructureCloudaccountsDotnewDotazure_DotcallbackRoute:
    InfrastructureCloudaccountsDotnewDotazure_DotcallbackRoute,
  InfrastructureCloudaccountsDotnewDotgcp_DotcallbackRoute:
    InfrastructureCloudaccountsDotnewDotgcp_DotcallbackRoute,
};

const consoleOrgRouteWithChildren = consoleOrgRoute._addFileChildren(
  consoleOrgRouteChildren,
);

interface consoleAccountRouteChildren {
  PrivacyRoute: typeof PrivacyRoute;
  ProfileRoute: typeof ProfileRoute;
  SecurityRoute: typeof SecurityRoute;
  SshkeysRoute: typeof SshkeysRoute;
  IndexRoute: typeof IndexRoute;
}

const consoleAccountRouteChildren: consoleAccountRouteChildren = {
  PrivacyRoute: PrivacyRoute,
  ProfileRoute: ProfileRoute,
  SecurityRoute: SecurityRoute,
  SshkeysRoute: SshkeysRoute,
  IndexRoute: IndexRoute,
};

const consoleAccountRouteWithChildren = consoleAccountRoute._addFileChildren(
  consoleAccountRouteChildren,
);

interface marketplaceWorkspaceRouteChildren {
  marketplaceViewRoute: typeof marketplaceViewRoute;
}

const marketplaceWorkspaceRouteChildren: marketplaceWorkspaceRouteChildren = {
  marketplaceViewRoute: marketplaceViewRoute,
};

const marketplaceWorkspaceRouteWithChildren =
  marketplaceWorkspaceRoute._addFileChildren(marketplaceWorkspaceRouteChildren);

interface consoleAuthedRouteChildren {
  consoleOrgRoute: typeof consoleOrgRouteWithChildren;
  consoleAccountRoute: typeof consoleAccountRouteWithChildren;
  MfaRoute: typeof MfaRoute;
  MovedRoute: typeof MovedRoute;
  OnboardingRoute: typeof OnboardingRoute;
  marketplaceWorkspaceRoute: typeof marketplaceWorkspaceRouteWithChildren;
  marketplaceIndexRoute: typeof marketplaceIndexRoute;
  CliAuthDotdeviceRoute: typeof CliAuthDotdeviceRoute;
  InviteDottokenRoute: typeof InviteDottokenRoute;
  marketplaceOrgRoute: typeof marketplaceOrgRoute;
  OauthDotconsentRoute: typeof OauthDotconsentRoute;
  CliAuthDotindexRoute: typeof CliAuthDotindexRoute;
}

const consoleAuthedRouteChildren: consoleAuthedRouteChildren = {
  consoleOrgRoute: consoleOrgRouteWithChildren,
  consoleAccountRoute: consoleAccountRouteWithChildren,
  MfaRoute: MfaRoute,
  MovedRoute: MovedRoute,
  OnboardingRoute: OnboardingRoute,
  marketplaceWorkspaceRoute: marketplaceWorkspaceRouteWithChildren,
  marketplaceIndexRoute: marketplaceIndexRoute,
  CliAuthDotdeviceRoute: CliAuthDotdeviceRoute,
  InviteDottokenRoute: InviteDottokenRoute,
  marketplaceOrgRoute: marketplaceOrgRoute,
  OauthDotconsentRoute: OauthDotconsentRoute,
  CliAuthDotindexRoute: CliAuthDotindexRoute,
};

const consoleAuthedRouteWithChildren = consoleAuthedRoute._addFileChildren(
  consoleAuthedRouteChildren,
);

const rootRouteChildren: RootRouteChildren = {
  consoleIndexRoute: consoleIndexRoute,
  consoleAuthedRoute: consoleAuthedRouteWithChildren,
  ForgotPasswordRoute: ForgotPasswordRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SignInRoute: SignInRoute,
  SignUpRoute: SignUpRoute,
  VerifyEmailRoute: VerifyEmailRoute,
  AuthDotcallbackRoute: AuthDotcallbackRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
